import { SetterOrUpdater, useRecoilValue } from "recoil";
import {
    CustomerListType,
    DepartmentSimpleType,
    PermissionsType,
    SecretarySimpleType,
    SelectedParametersType,
    UserType,
    VehicleBrandType,
    VehicleColorType,
    VehicleDialogSection,
    VehicleDirectdLookupType,
    VehicleModelType,
    VehicleRequestType,
    VehicleType,
    VehicleTypesType,
} from "../../../types/types";
import { GridColDef } from "@mui/x-data-grid";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    FormGroup,
    FormHelperText,
    Grid,
    IconButton,
    InputLabel,
    Paper,
    Skeleton,
    Stack,
    styled,
    Switch,
    SwitchProps,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import {
    AbcOutlined,
    CheckCircleOutlineOutlined,
    CheckCircleRounded,
    CloseOutlined,
    DescriptionOutlined,
    DeviceHubOutlined,
    DoNotDisturbOnRounded,
    DriveFileRenameOutlineOutlined,
    HelpOutlineOutlined,
    KeyOutlined,
    LocalAtmOutlined,
    LocalShippingRounded,
    PinOutlined,
    RemoveCircleOutlineOutlined,
    RequestPageOutlined,
    Settings,
    SatelliteAltOutlined,
    SaveOutlined,
    SearchOutlined,
    TapAndPlayOutlined,
    VideoCameraFrontOutlined,

    // novos
    BuildOutlined,
    AttachMoneyOutlined,
    AttachFileOutlined,
    SettingsOutlined,
    ArrowBackOutlined,
    SwapHorizOutlined,
} from "@mui/icons-material";
import {
    ChangeEvent,
    SyntheticEvent,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { ContentProps, Toast } from "primereact/toast";
import {
    currencyFormatter,
    getFilteredList,
    setToastRefToOpen,
} from "../../../functions/functions";
import GridTemplate from "../../../components/GridTemplate";
import Rmodal from "../../../components/Rmodal";

import {
    ArrowDropDownIcon,
    DatePicker,
    LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

import "dayjs/locale/pt-br";
import findAllVehiclesByDepartmentIdCrudResponse from "../../../resources/Api/vehicle/findAllVehiclesByDepartmentIdCrudResponse";
import findAllVehicleBrandsListResponse from "../../../resources/Api/vehicle/findAllVehicleBrandsListResponse";
import findAllVehicleModelByBrandListResponse from "../../../resources/Api/vehicle/findAllVehicleModelsByBrandsListResponse";
import findAllVehicleTypesListResponse from "../../../resources/Api/vehicle/findAllVehicleTypesListResponse";
import findAllVehicleColorsListResponse from "../../../resources/Api/vehicle/findAllAllVehicleColorsListResponse";
import saveVehicleByCustomerAndDepartment from "../../../resources/Api/vehicle/saveVehicleByCustomerAndDepartment";
import updateVehicleByCustomerAndDepartment from "../../../resources/Api/vehicle/updateVehicleByCustomerAndDepartment";
import updateVehicleStatusById from "../../../resources/Api/vehicle/updateVehicleStatusById";
import findAllVehiclesExportResponse from "../../../resources/Api/vehicle/findAllVVehiclesExportResponse";
import { userAtom } from "../../../atoms/atoms";
import customerFindAllListResponse from "../../../resources/Api/customer/customerFindAllListResponse";
import findAllSecretariesByCustomerIdListResponse from "../../../resources/Api/secretary/findAllSecretariesByCustomerIdListResponse";
import findAllDepartmentsByCustomerIdAndSecretaryIdListResponse from "../../../resources/Api/department/findAllDepartmentsByCustomerIdAndSecretaryIdListResponse";
import {
    customerDefault,
    departmentDefault,
    PROFILE_ACESSES,
    secretaryDefault,
    MENUS_ITENS,
} from "../../../consts/consts";
import userFindAllSecretariesListResponse from "../../../resources/Api/user/userFindAllSecretariesListResponse";
import userFindAllDepartmentsListResponse from "../../../resources/Api/user/userFindAllDepartmentsListResponse";
import VehicleMaintenance from "./VehicleMaintenance";
import VehicleExpense from "./vehicleExpense";
import VehicleParameter from "./vehicleParameter";
import { isImpersonationLocked } from "../../../utils/impersonation";
import findVehicleDirectdByPlate from "../../../resources/Api/vehicle/findVehicleDirectdByPlate";
import DirectdIndicators from "../../../components/DirectdIndicators";
import useDirectdLookup from "../../../hooks/useDirectdLookup";

/** Placa antiga (AAA9999) ou Mercosul (AAA9A99), ja sem hifen e em maiusculas. */
const VEHICLE_PLATE_PATTERN = /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/;
const normalizePlate = (raw: string): string => raw.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
const isValidPlate = (plate: string): boolean => VEHICLE_PLATE_PATTERN.test(plate);

const columns: GridColDef[] = [
    {
        field: "activated",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Ativo"}
                icon={<KeyOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{ background: "transparent" }}
                icon={
                    item.row.activated ? (
                        <CheckCircleRounded
                            className="activated"
                            style={{ height: 28, width: 28 }}
                        />
                    ) : (
                        <DoNotDisturbOnRounded
                            className="deactivated"
                            style={{ height: 28, width: 28 }}
                        />
                    )
                }
            />
        ),
    },
    {
        field: "name",
        align: "left",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Nome"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.name}
            />
        ),
    },
    {
        field: "plate",
        width: 150,
        align: "left",
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Placa"}
                icon={<PinOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.vehiclePlate}
            />
        ),
    },
    {
        field: "deviceImei",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"IMEI"}
                icon={
                    <DescriptionOutlined
                        style={{ height: 30, width: 30, fill: "#ffff" }}
                    />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.deviceImei ?? "-"}
            />
        ),
    },
    {
        field: "satelliteImei",
        align: "left",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"ESN"}
                icon={<PinOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.satelliteImei ?? "-"}
            />
        ),
    },
    {
        field: "departmentReducedName",
        align: "left",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Departamento"}
                icon={<PinOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.departmentReducedName ?? "-"}
            />
        ),
    },
    {
        field: "parameterIcon",
        sortable: false,
        headerName: "",
        width: 200,
        headerClassName: "last-column",
        cellClassName: "last-column",
        renderCell: (item: any) => {
            const getItemPermission = (id: number) => {
                return item.row.permissions.find((permission: PermissionsType) => {
                    if (permission.optionItem.id === id) {
                        const { optionItem, ...rest } = permission;
                        return rest;
                    }
                });
            };

            const permissions = getItemPermission(Number(MENUS_ITENS.VEHICLES));
            return (
                <>
                <Chip
                    disabled={!permissions.canView}
                    sx={{
                        marginRight: 2,
                        fontFamily: "Prometo",
                        background: permissions.canView ? "#00B700" : "#BDBDBD",
                        color: "#ffff",
                        padding: 1,
                    }}
                    onClick={(e) => {
                        e.stopPropagation();

                        if (!permissions.canView) return;

                        if (item.row.openDetails) {
                            item.row.openDetails(true);
                        }

                        if (item.row.callback) {
                            item.row.callback?.(item.row);
                        }
                    }}
                    label="Parâmetros"
                    icon={<Settings style={{ height: 25, width: 25, fill: "#ffff" }} />}
                />
                {item.row.onTransfer && item.row.activated && (
                    <Tooltip title="Transferir veículo" arrow>
                        <IconButton
                            aria-label="Transferir veículo"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                item.row.onTransfer(item.row);
                            }}
                            sx={{ color: "#006C77", "&:hover": { backgroundColor: "rgba(0, 108, 119, 0.08)" } }}
                        >
                            <SwapHorizOutlined />
                        </IconButton>
                    </Tooltip>
                )}
                </>
            );
        },
    },
];

const rowsOptions = (
    list: Array<VehicleType>,
    openDetails?: SetterOrUpdater<boolean>,
    callback?: (...args: any) => void,
    showOptions?: boolean,
    permissions?: Array<PermissionsType>,
    canshowOption: boolean = true,
    onTransfer?: (vehicle: VehicleType) => void,
): Array<VehicleType> => {
    const result = [...list];
    return result.map((item) => ({
        ...item,
        openDetails,
        callback,
        showOptions,
        permissions,
        canshowOption,
        onTransfer,
    }));
};

const IOSSwitch = styled((props: SwitchProps) => (
    <Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
    />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(16px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: "#65C466",
                opacity: 1,
                border: 0,
                ...theme.applyStyles("dark", {
                    backgroundColor: "#2ECA45",
                }),
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
            },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: "#33cf4d",
            border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
            color: theme.palette.grey[100],
            ...theme.applyStyles("dark", {
                color: theme.palette.grey[600],
            }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.7,
            ...theme.applyStyles("dark", {
                opacity: 0.3,
            }),
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 22,
        height: 22,
    },
    "& .MuiSwitch-track": {
        borderRadius: 13,
        backgroundColor: "#E9E9EA",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
            duration: 500,
        }),
        ...theme.applyStyles("dark", {
            backgroundColor: "#39393D",
        }),
    },
}));

/**
 * VehiclePage - Component that renders a page to list, create and manage vehicles
 * @component
 */
const VehiclePage = ({ isHiddenMenu }: { isHiddenMenu: boolean }) => {
    //atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);

    // functionalities states
    const [isOnline, setIsOnline] = useState(true);
    const [loading, setLoading] = useState(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);

    const [statusMessage, setStatusMessage] = useState<
        "warn" | "success" | "info" | "error" | undefined
    >("warn");

    const [isToastVisible, setIsToastVisible] = useState(false);
    const [inEdit, setInEdit] = useState<boolean>(false);
    const [inInsert, setInInsert] = useState<boolean>(false);
    const [useSatellite, setUseSatellite] = useState<boolean>(false);

    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [infoExpanded, setInfoExpanded] = useState<boolean>(true);
    const [info2Expanded, setInfo2Expanded] = useState<boolean>(false);

    const [query, setQuery] = useState<string>("");
    const [filteredList, setFilteredList] = useState<Array<VehicleType>>([]);

    const [isLastPage, setIsLastPage] = useState<boolean>(true);
    const [numberOfElementsPerPage, setNumberOfElementsPerPage] =
        useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);

    // states
    const [vehicleList, setVehicleList] = useState<Array<VehicleType>>([]);
    const [selectedVehicle, setSelectedVehicle] = useState<VehicleType>({
        id: -1,
    } as any);

    const [vehicleBrandsList, setVehicleBrandsList] = useState<
        Array<VehicleBrandType>
    >([]);
    const [vehicleModelsList, setVehicleModelList] = useState<
        Array<VehicleModelType>
    >([]);
    const [vehicleColorsList, setVehicleColorsList] = useState<
        Array<VehicleColorType>
    >([]);
    const [vehicleTypesList, setVehicleTypesList] = useState<
        Array<VehicleTypesType>
    >([]);

    const [vehicleName, setVehicleName] = useState<string>("");
    const [vehiclePlate, setVehiclePlate] = useState<string>("");
    const [vehicleBrandName, setVehicleBrandName] = useState<string>("");
    const [vehicleModelName, setVehicleModelName] = useState<string>("");
    const [vehicleColorName, setVehicleColorName] = useState<string>("");
    const [vehicleTypeName, setVehicleTypeName] = useState<string>("");
    const [vehicleFrame, setVehicleFrame] = useState<string | null>("");
    const [vehicleMadeYear, setVehicleMadeYear] = useState<Dayjs>(dayjs());
    const [vehicleModelYear, setVehicleModelYear] = useState<Dayjs>(dayjs());
    const [contractNumber, setContractNumber] = useState<string | null>("");
    const [monthBilling, setMonthBilling] = useState<string | null>("");
    const [contractBilling, setContractBiling] = useState<string | null>("");

    const [deviceCameraIdentifier, setDeviceCameraIdentifier] = useState<
        string | null
    >("");
    const [deviceSatelliteIdentifier, setDeviceSatelliteIdentifier] = useState<
        string | null
    >("");
    const [deviceIdentifier, setDeviceIdentifier] = useState<string | null>("");

    const [report, setReport] = useState<ArrayBuffer>(new ArrayBuffer(0));
    const [exportType, setExportType] = useState<string>("");

    const [secretariesList, setSecretariesList] = useState<
        Array<SecretarySimpleType>
    >([]);
    const [departmentsList, setDepartmentsList] = useState<
        Array<DepartmentSimpleType>
    >([]);
    const [customersList, setCustomersList] = useState<Array<CustomerListType>>(
        [],
    );

    const [customer, setCustomer] = useState<CustomerListType>(customerDefault);
    const [secretary, setSecretary] =
        useState<SecretarySimpleType>(secretaryDefault);
    const [department, setDepartment] =
        useState<DepartmentSimpleType>(departmentDefault);

    const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
    const [isOpenDialogCameraField, setIsOpenDialogCameraField] =
        useState<boolean>(false);
    const [isViewingAll, setIsViewingAll] = useState(false);
    const [historySearch, setHistorySearch] = useState<string>("");


    const [isOpenVehicleParameter, setIsOpenVehicleParameter] =
        useState<boolean>(false);
    const [vehicleDialogHasUnsavedChanges, setVehicleDialogHasUnsavedChanges] =
        useState<boolean>(false);

    const [vehicleDialogSection, setVehicleDialogSection] =
        useState<VehicleDialogSection>("parameters");
    const [vehicleDialogContentHeight, setVehicleDialogContentHeight] =
        useState<number | null>(null);


    const [debouncedQuery, setDebouncedQuery] = useState(query);
    const [lastRemoteQuery, setLastRemoteQuery] = useState("");


    // refs
    const toastModalRef = useRef<Toast>(null);
    const toastVehicleDialogRef = useRef<Toast>(null);
    const toastRef = useRef<Toast>(null);
    const vehicleDialogContentRef = useRef<HTMLDivElement>(null);

    // cookies
    const [cookies, _] = useCookies(["selectedParameters", "token"]);

    const location = useLocation();
    const navigate = useNavigate();

    // Atalho para Ferramentas > Transferência de veículo (rota existe só no app da administradora).
    // Leva o veículo para a outra tela já pré-selecionado.
    const isAdmin = getCurrentUser.configs.isManager && String(getCurrentUser.accessProfile.id) === PROFILE_ACESSES.ADMIN;
    const transferSourceCustomerId = location?.state?.customerId ?? customer.id;
    const openVehicleTransfer = useCallback((vehicle: VehicleType) => {
        navigate("/help-desk", {
            state: {
                tab: 0,
                transferMode: isAdmin ? "customer" : "department",
                sourceCustomerId: transferSourceCustomerId > 0 ? transferSourceCustomerId : undefined,
                vehicleId: vehicle.id,
                vehiclePlate: vehicle.vehiclePlate,
                departmentId: vehicle.departmentId,
                secretaryId: vehicle.departmentSecretaryId,
            },
        });
    }, [navigate, isAdmin, transferSourceCustomerId]);
    const canTransferVehicle = getCurrentUser.configs.isManager && localStorage.getItem("impersonating") !== "true";


    const currentParameters: SelectedParametersType = useMemo(
        () => cookies.selectedParameters,
        [cookies.selectedParameters],
    );

    const handleCloseHistory = useCallback(() => {
        setIsOpenDialog(false);
        setHistorySearch("");
    }, []);

    const handleClose = useCallback(() => {
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setTextValidation("");
        setIsOpenDetails(false);
        setInEdit(false);
        setInInsert(false);
        setVehicleName("");
        setVehiclePlate("");
        setVehicleBrandName("");
        setVehicleTypeName("");
        setVehicleFrame("");
        setVehicleMadeYear(dayjs());
        setVehicleModelYear(dayjs());
        setContractNumber("");
        setMonthBilling("");
        setContractBiling("");
        setDeviceIdentifier("");
        setVehicleColorName("");
        setVehicleModelName("");
        setInfo2Expanded(false);
        setInfoExpanded(true);
        setUseSatellite(false);
        setDeviceSatelliteIdentifier("");
        setDeviceCameraIdentifier("");
        setIsOpenDialogCameraField(false);
        setIsOpenVehicleParameter(false);
        setSelectedVehicle({
            id: -1,
        } as any);
        setHistorySearch("");
    }, []);

    useEffect(() => {
        const ref = isOpenVehicleParameter
            ? toastVehicleDialogRef
            : isOpenDetails
                ? toastModalRef
                : toastRef;
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                ref,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false,
            );
        }
    }, [
        isOpenDetails,
        isOpenVehicleParameter,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
    ]);

    const getSecretariesList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const userId = getCurrentUser.id;
        try {
            const response = await userFindAllSecretariesListResponse(token, userId);
            setSecretariesList(response.data);
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, getCurrentUser.id]);

    useEffect(() => {
        if (currentParameters?.isViewingAll && !getCurrentUser.configs.isManager) {
            getSecretariesList();
        }
    }, [
        getSecretariesList,
        currentParameters?.isViewingAll,
        getCurrentUser.configs.isManager,
    ]);

    const getDepartmentsList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const userId = getCurrentUser.id;

        try {
            const response = await userFindAllDepartmentsListResponse(
                token,
                userId,
                secretary?.id,
            );
            setDepartmentsList(response.data);
        } catch (error) {
            console.log(error);
            setDepartmentsList([]);
        }
    }, [cookies.token, getCurrentUser.id, secretary.id]);

    useEffect(() => {
        if (
            currentParameters?.isViewingAll &&
            !getCurrentUser.configs.isManager &&
            secretary?.name
        ) {
            getDepartmentsList();
        }
    }, [
        getDepartmentsList,
        secretary?.name,
        getCurrentUser.configs.isManager,
        currentParameters?.isViewingAll,
    ]);

    const getAllVehicles = useCallback(
        async (
            search: string = "",
            status: string = "activated",
            page: number = 0,
            size: number = 100,
        ) => {
            const token: string = cookies.token || sessionStorage.getItem("token");

            const customerId =
                location?.state?.customerId ??
                (!getCurrentUser.configs.isManager
                    ? currentParameters.customer.id
                    : customer.id);
            const departmentId =
                location?.state?.departmentId ??
                (!getCurrentUser.configs.isManager && !currentParameters.isViewingAll
                    ? currentParameters.department.id
                    : department.id);
            const isViewAll =
                getCurrentUser.configs.isManager && !location?.state?.departmentId
                    ? isViewingAll
                    : !getCurrentUser.configs.isManager && currentParameters.isViewingAll;

            setLoading(true);
            try {
                const { data } = await findAllVehiclesByDepartmentIdCrudResponse(
                    token,
                    customerId,
                    departmentId,
                    status,
                    page,
                    size,
                    isViewAll,
                    search,
                );

                setVehicleList(data.content);
                setIsLastPage(data.last);
                setNumberOfElementsPerPage(data.numberOfElements);
                setPageNumber(data.pageable.pageNumber);

                if (data.first) {
                    setNumberOfElements(data.totalElements);
                }
            } catch (error: any) {
                console.log(error);
                setVehicleList([]);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        },
        [
            isViewingAll,
            cookies.token,
            location?.state?.customerId,
            location?.state?.departmentId,
            currentParameters.customer.id,
            currentParameters.department.id,
            currentParameters.isViewingAll,
            customer.id,
            department.id,
            getCurrentUser.configs.isManager,
        ],
    );

    useEffect(() => {
        getAllVehicles();
    }, [getAllVehicles]);

    const getBrandsList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        setLoading(true);
        try {
            const { data } = await findAllVehicleBrandsListResponse(token);
            setVehicleBrandsList(data);
        } catch (error: any) {
            console.log(error);
            setVehicleBrandsList([]);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }, [cookies.token]);

    useEffect(() => {
        getBrandsList();
    }, [getBrandsList]);

    const getModelsList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const stateId = vehicleBrandsList.find((item) => {
            if (item.name === vehicleBrandName) return item;
        })?.id;
        try {
            const { data } = await findAllVehicleModelByBrandListResponse(
                token,
                stateId!!,
            );
            setVehicleModelList(data);

            if (selectedVehicle?.name) {
                const modelName = data.find(
                    (item: any) => item.id === selectedVehicle.vehicleModelId,
                )?.name;

                if (modelName) setVehicleModelName(modelName);
            }
        } catch (error: any) {
            console.log(error);
            setVehicleModelList([]);
        }
    }, [
        cookies.token,
        vehicleBrandName,
        vehicleBrandsList,
        selectedVehicle.name,
        selectedVehicle.vehicleModelId,
    ]);

    useEffect(() => {
        if (vehicleBrandName) {
            getModelsList();
        }
    }, [getModelsList, vehicleBrandName]);

    const getVehicleTypesList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        try {
            const { data } = await findAllVehicleTypesListResponse(token);
            setVehicleTypesList(data);
        } catch (error: any) {
            console.log(error);
            setVehicleTypesList([]);
        }
    }, [cookies.token]);

    useEffect(() => {
        getVehicleTypesList();
    }, [getVehicleTypesList]);

    const getVehicleColorsList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        try {
            const { data } = await findAllVehicleColorsListResponse(token);
            setVehicleColorsList(data);
        } catch (error: any) {
            console.log(error);
            setVehicleColorsList([]);
        }
    }, [cookies.token]);

    useEffect(() => {
        getVehicleColorsList();
    }, [getVehicleColorsList]);

    const requestVehicleDialogConfirmation = useCallback(
        (onConfirm: () => void) => {
            const ref = toastVehicleDialogRef;

            if (isToastVisible) {
                return;
            }

            setToastRefToOpen(
                ref,
                "Existem dados não salvos, deseja realmente cancelar?",
                "Atenção!",
                "warn",
                {
                    content: (props: ContentProps) => (
                        <Box
                            className="flex flex-column align-items-left"
                            style={{ flex: "1" }}
                        >
                            <Typography>{props?.message.summary}</Typography>
                            <Box className="font-medium text-lg my-3 text-900">
                                {props?.message.detail}
                            </Box>
                            <Button
                                className="p-button-sm flex"
                                style={{ cursor: "pointer", color: "inherit" }}
                                onClick={() => {
                                    ref.current?.clear();
                                    setIsToastVisible(false);
                                    setVehicleDialogHasUnsavedChanges(false);
                                    onConfirm();
                                }}
                            >
                                Sim
                            </Button>
                            <Button
                                className="p-button-sm flex"
                                style={{ cursor: "pointer", color: "inherit" }}
                                onClick={() => {
                                    ref.current?.clear();
                                    setIsToastVisible(false);
                                }}
                            >
                                Não
                            </Button>
                        </Box>
                    ),
                },
                undefined,
                true,
            );
            setIsToastVisible(true);
        },
        [isToastVisible],
    );

    const verifyBeforeLeavingVehicleSection = useCallback(
        (onConfirm: () => void) => {
            if (vehicleDialogHasUnsavedChanges) {
                requestVehicleDialogConfirmation(onConfirm);
                return;
            }

            onConfirm();
        },
        [vehicleDialogHasUnsavedChanges, requestVehicleDialogConfirmation],
    );

    const handleOpenVehicleMaintenance = useCallback(() => {
        if (!selectedVehicle?.id || selectedVehicle.id <= 0) {
            return;
        }

        if (vehicleDialogSection !== "maintenance") {
            verifyBeforeLeavingVehicleSection(() => {
                setVehicleDialogSection("maintenance");
            });
        }
    }, [
        selectedVehicle?.id,
        vehicleDialogSection,
        verifyBeforeLeavingVehicleSection,
    ]);

    const handleOpenVehicleExpenses = useCallback(() => {
        if (!selectedVehicle?.id || selectedVehicle.id <= 0) {
            return;
        }

        if (vehicleDialogSection !== "expenses") {
            verifyBeforeLeavingVehicleSection(() => {
                setVehicleDialogSection("expenses");
            });
        }
    }, [
        selectedVehicle?.id,
        vehicleDialogSection,
        verifyBeforeLeavingVehicleSection,
    ]);

    const handleOpenVehicleAttachments = useCallback(() => {
        if (!selectedVehicle?.id || selectedVehicle.id <= 0) {
            return;
        }

        if (vehicleDialogSection !== "attachments") {
            verifyBeforeLeavingVehicleSection(() => {
                setVehicleDialogSection("attachments");
            });
        }
    }, [
        selectedVehicle?.id,
        vehicleDialogSection,
        verifyBeforeLeavingVehicleSection,
    ]);

    /**
     * Consulta da placa na Direct Data (paga; o backend guarda cache de 30 dias), no onBlur e depois de uma pausa
     * na digitacao. Na inclusao sobrescreve os campos; na edicao so preenche os vazios e nao consulta a placa salva.
     */
    const normalizedPlate = normalizePlate(vehiclePlate);
    // Placa em que o usuario saiu do campo: a mensagem de invalida so aparece com a placa completa ou depois do blur.
    const [plateBlurredValue, setPlateBlurredValue] = useState<string>("");
    const isPlateInvalid =
        (inInsert || inEdit) &&
        normalizedPlate.length > 0 &&
        !isValidPlate(normalizedPlate) &&
        (normalizedPlate.length === 7 || plateBlurredValue === normalizedPlate) &&
        !(inEdit && normalizedPlate === (selectedVehicle?.vehiclePlate ?? "").toUpperCase());

    const {
        loading: directdLoading,
        result: directdResult,
        error: directdError,
        lookupNow: lookupPlateNow,
    } = useDirectdLookup<VehicleDirectdLookupType>({
        rawValue: vehiclePlate,
        normalize: normalizePlate,
        isValid: isValidPlate,
        enabled: inInsert || inEdit,
        shouldSkip: (plate) => inEdit && plate === (selectedVehicle?.vehiclePlate ?? "").toUpperCase(),
        fetcher: async (plate) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const { data } = await findVehicleDirectdByPlate(token, plate);
            return data as VehicleDirectdLookupType;
        },
        onResult: (result) => {
            const fill = <P extends string | null>(setter: (updater: (previous: P) => P) => void, value: string | null | undefined) => {
                if (!value) return;
                setter((previous) => (inInsert || !previous ? (value as P) : previous));
            };

            const brandName = vehicleBrandsList.find((item) => item.id === result.vehicleBrandId)?.name;
            if (brandName && (inInsert || !vehicleBrandName)) {
                setVehicleBrandName(brandName);
                setVehicleModelName(result.vehicleModelCatalogName ?? "");
            }
            fill(setVehicleTypeName, vehicleTypesList.find((item) => item.id === result.vehicleTypeId)?.name);
            fill(setVehicleColorName, vehicleColorsList.find((item) => item.id === result.vehicleColorId)?.name);
            fill(setVehicleFrame, result.chassis);
            if (inInsert && result.madeYear) setVehicleMadeYear(dayjs().year(Number(result.madeYear)));
            if (inInsert && result.modelYear) setVehicleModelYear(dayjs().year(Number(result.modelYear)));
        },
    });

    const onSave = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");

        const customerId =
            location?.state?.customerId ??
            (!getCurrentUser.configs.isManager
                ? currentParameters.customer.id
                : customer.id);
        const departmentId =
            location?.state?.departmentId ??
            (!getCurrentUser.configs.isManager && !currentParameters.isViewingAll
                ? currentParameters.department.id
                : department.id);

        setLoading(true);

        const vehicleBrandId =
            vehicleBrandsList.find((item) => item.name === vehicleBrandName)?.id ??
            null;

        const vehicleModelId =
            vehicleModelsList.find((item) => item.name === vehicleModelName)?.id ??
            null;

        const vehicleTypeId = vehicleTypesList.find(
            (item) => item.name === vehicleTypeName,
        )?.id;

        const vehicleColorId = vehicleColorsList.find(
            (item) => item.name === vehicleColorName,
        )?.id;

        const data: VehicleRequestType = {
            id: -1,
            name: vehicleName ?? "",
            customerId: customerId,
            departmentId: departmentId,
            deviceImei: deviceIdentifier,
            useSatellite: useSatellite,
            satelliteImei: deviceSatelliteIdentifier,
            vehicleBrandId: vehicleBrandId,
            vehicleModelId: vehicleModelId,
            vehicleTypeId: vehicleTypeId!!,
            vehicleColorId: vehicleColorId!!,
            vehicleFrame: vehicleFrame?.length!! > 0 ? vehicleFrame : null,
            deviceCameraImei: deviceCameraIdentifier,
            vehicleMadeYear: vehicleMadeYear.year().toString(),
            vehicleModelYear: vehicleModelYear.year().toString(),
            vehiclePlate: vehiclePlate,
            contractBilling:
                contractBilling?.replace(/[^\d]/g, "").length!! > 0
                    ? contractBilling
                    : null,
            contractNumber: contractNumber?.length!! > 0 ? contractNumber : null,
            monthBilling:
                monthBilling?.replace(/[^\d]/g, "").length!! > 0 ? monthBilling : null,
            drivers: [],
        };

        if (
            !data.vehicleTypeId ||
            !data.vehicleColorId ||
            !data.vehiclePlate ||
            !data.name
        ) {
            setTextValidation(
                "Todos os campos marcados com * são obrigatórios, preencha e tente novamente.",
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await saveVehicleByCustomerAndDepartment(token, data);
            setTextValidation("Registro salvo com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllVehicles();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        currentParameters.customer.id,
        currentParameters.department.id,
        currentParameters.isViewingAll,
        deviceCameraIdentifier,
        customer.id,
        department.id,
        getCurrentUser.configs.isManager,
        location?.state?.customerId,
        location?.state?.departmentId,
        cookies.token,
        vehicleName,
        vehicleBrandName,
        vehicleModelName,
        vehicleTypeName,
        vehicleColorName,
        vehicleFrame,
        vehicleMadeYear,
        vehicleModelYear,
        vehiclePlate,
        contractBilling,
        contractNumber,
        monthBilling,
        deviceIdentifier,
        vehicleBrandsList,
        vehicleColorsList,
        vehicleModelsList,
        vehicleTypesList,
        handleClose,
        getAllVehicles,
        useSatellite,
        deviceSatelliteIdentifier,
    ]);

    const onUpdate = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");

        const customerId =
            location?.state?.customerId ??
            (!getCurrentUser.configs.isManager
                ? currentParameters.customer.id
                : customer.id);
        const departmentId =
            location?.state?.departmentId ??
            (!getCurrentUser.configs.isManager && !currentParameters.isViewingAll
                ? currentParameters.department.id
                : department.id);

        setLoading(true);

        const vehicleBrandId =
            vehicleBrandsList.find((item) => item.name === vehicleBrandName)?.id ??
            null;
        const vehicleModelId =
            vehicleModelsList.find((item) => item.name === vehicleModelName)?.id ??
            null;
        const vehicleTypeId = vehicleTypesList.find(
            (item) => item.name === vehicleTypeName,
        )?.id;
        const vehicleColorId = vehicleColorsList.find(
            (item) => item.name === vehicleColorName,
        )?.id;

        const data: VehicleRequestType = {
            id: selectedVehicle.id,
            name: vehicleName ?? "",
            customerId: customerId,
            departmentId: departmentId,
            deviceImei: deviceIdentifier,
            useSatellite: useSatellite,
            satelliteImei: deviceSatelliteIdentifier,
            deviceCameraImei: deviceCameraIdentifier,
            vehicleBrandId: vehicleBrandId,
            vehicleModelId: vehicleModelId,
            vehicleTypeId: vehicleTypeId!!,
            vehicleColorId: vehicleColorId!!,
            vehicleFrame: vehicleFrame?.length!! > 0 ? vehicleFrame : null,
            vehicleMadeYear: vehicleMadeYear.year().toString(),
            vehicleModelYear: vehicleModelYear.year().toString(),
            vehiclePlate: vehiclePlate,
            contractBilling:
                contractBilling?.replace(/[^\d]/g, "").length!! > 0
                    ? contractBilling
                    : null,
            contractNumber: contractNumber?.length!! > 0 ? contractNumber : null,
            monthBilling:
                monthBilling?.replace(/[^\d]/g, "").length!! > 0 ? monthBilling : null,
            drivers: [],
        };

        if (
            !data.vehicleTypeId ||
            !data.vehicleColorId ||
            !data.vehiclePlate ||
            !data.name
        ) {
            setTextValidation(
                "Todos os campos marcados com * são obrigatórios, preencha e tente novamente.",
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        const managerValidation = getCurrentUser.configs.isManager
            ? (contractBilling == ""
                ? null
                : contractBilling?.replace(/[^\d]/g, "")) ===
            selectedVehicle?.contractBilling &&
            contractNumber === selectedVehicle?.contractNumber &&
            (monthBilling == "" ? null : monthBilling?.replace(/[^\d]/g, "")) ===
            selectedVehicle?.monthBilling &&
            deviceIdentifier === selectedVehicle?.deviceImei &&
            deviceSatelliteIdentifier === selectedVehicle?.satelliteImei &&
            deviceCameraIdentifier === selectedVehicle?.deviceCameraImei &&
            useSatellite === selectedVehicle.useSatellite
            : true;

        if (
            vehicleName === selectedVehicle.name &&
            vehicleBrandId === selectedVehicle?.vehicleBrandId &&
            vehicleModelId === selectedVehicle?.vehicleModelId &&
            vehicleTypeId === selectedVehicle.vehicleTypeId &&
            vehicleColorId === selectedVehicle.vehicleColorId &&
            vehicleFrame === selectedVehicle?.vehicleFrame &&
            selectedVehicle?.vehicleMadeYear &&
            vehicleMadeYear.year() ===
            dayjs().year(selectedVehicle?.vehicleMadeYear).year() &&
            selectedVehicle?.vehicleModelYear &&
            vehicleModelYear.year() ===
            dayjs().year(selectedVehicle?.vehicleModelYear).year() &&
            vehiclePlate === selectedVehicle.vehiclePlate &&
            managerValidation
        ) {
            setTextValidation("Nada foi alterado.");
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await updateVehicleByCustomerAndDepartment(token, data.id, data);
            setTextValidation("Registro atualizado com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllVehicles();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        selectedVehicle,
        location?.state?.customerId,
        location?.state?.departmentId,
        currentParameters.customer.id,
        currentParameters.department.id,
        currentParameters.isViewingAll,
        deviceCameraIdentifier,
        department.id,
        customer.id,
        getCurrentUser.configs.isManager,
        cookies.token,
        vehicleName,
        vehicleBrandName,
        vehicleModelName,
        vehicleTypeName,
        vehicleColorName,
        vehicleFrame,
        vehicleMadeYear,
        vehicleModelYear,
        vehiclePlate,
        contractBilling,
        contractNumber,
        monthBilling,
        deviceIdentifier,
        vehicleBrandsList,
        vehicleColorsList,
        vehicleModelsList,
        vehicleTypesList,
        useSatellite,
        deviceSatelliteIdentifier,
        handleClose,
        getAllVehicles,
    ]);

    useEffect(() => {
        setFilteredList(
            getFilteredList(
                [
                    "name",
                    "vehiclePlate",
                    "deviceImei",
                    "satelliteImei",
                    "contractNumber",
                    "vehicleFrame",
                ],
                vehicleList,
                query,
            ),
        );
    }, [vehicleList, query]);

    const invalidVehicleDates = useMemo(() => {
        let showError = false;
        if (dayjs(vehicleModelYear).isBefore(dayjs(vehicleMadeYear))) {
            showError = true;
        } else if (
            dayjs(vehicleModelYear).isAfter(dayjs(vehicleMadeYear).add(1, "year"))
        ) {
            showError = true;
        }
        return showError;
    }, [vehicleModelYear, vehicleMadeYear]);

    const verifyBeforeCancel = useCallback(
        (selected: VehicleType) => {
            const ref = toastModalRef;
            let canCancel = true;

            if (inEdit && !inInsert) {
                const vehicleBrandId =
                    vehicleBrandsList.find((item) => item.name === vehicleBrandName)
                        ?.id ?? null;
                const vehicleModelId =
                    vehicleModelsList.find((item) => item.name === vehicleModelName)
                        ?.id ?? null;
                const vehicleTypeId = vehicleTypesList.find(
                    (item) => item.name === vehicleTypeName,
                )?.id;
                const vehicleColorId = vehicleColorsList.find(
                    (item) => item.name === vehicleColorName,
                )?.id;

                if (
                    vehicleName !== selected.name ||
                    vehicleBrandId !== selected?.vehicleBrandId ||
                    vehicleModelId !== selected?.vehicleModelId ||
                    vehicleTypeId !== selected.vehicleTypeId ||
                    vehicleColorId !== selected.vehicleColorId ||
                    vehicleFrame !== selected?.vehicleFrame ||
                    (selected?.vehicleMadeYear &&
                        vehicleMadeYear.year() !==
                        dayjs().year(selected?.vehicleMadeYear).year()) ||
                    (selected?.vehicleModelYear &&
                        vehicleModelYear.year() !==
                        dayjs().year(selected?.vehicleModelYear).year()) ||
                    vehiclePlate !== selected.vehiclePlate ||
                    (getCurrentUser.configs.isManager &&
                        (contractBilling === ""
                            ? null
                            : contractBilling?.replace(/[^\d]/g, "")) !==
                        selected?.contractBilling) ||
                    (getCurrentUser.configs.isManager &&
                        contractNumber !== selected?.contractNumber) ||
                    (getCurrentUser.configs.isManager &&
                        (monthBilling === ""
                            ? null
                            : monthBilling?.replace(/[^\d]/g, "")) !==
                        selected?.monthBilling) ||
                    (getCurrentUser.configs.isManager &&
                        (deviceIdentifier !== selected?.deviceImei ||
                            deviceSatelliteIdentifier !== selected?.satelliteImei ||
                            useSatellite !== selected.useSatellite ||
                            deviceCameraIdentifier !== selected?.deviceCameraImei))
                ) {
                    canCancel = false;
                }
            } else if (
                !inEdit &&
                inInsert &&
                (vehicleName ||
                    vehicleTypeName ||
                    vehicleColorName ||
                    vehicleFrame ||
                    vehiclePlate ||
                    contractBilling ||
                    contractNumber ||
                    monthBilling ||
                    deviceIdentifier ||
                    deviceSatelliteIdentifier)
            ) {
                canCancel = false;
            }

            if (!canCancel) {
                if (!isToastVisible) {
                    setToastRefToOpen(
                        ref,
                        "Existem dados não salvos, deseja realmente cancelar?",
                        "Atenção!",
                        statusMessage,
                        {
                            content: (props: ContentProps) => (
                                <Box
                                    className="flex flex-column align-items-left"
                                    style={{ flex: "1" }}
                                >
                                    <Typography>{props?.message.summary}</Typography>
                                    <Box className="font-medium text-lg my-3 text-900">
                                        {props?.message.detail}
                                    </Box>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            handleClose();
                                        }}
                                    >
                                        Sim
                                    </Button>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            setIsToastVisible(false);
                                        }}
                                    >
                                        Não
                                    </Button>
                                </Box>
                            ),
                        },
                        undefined,
                        true,
                    );
                    setIsToastVisible(true);
                }
            } else {
                handleClose();
            }
        },
        [
            inEdit,
            inInsert,
            handleClose,
            statusMessage,
            isToastVisible,
            vehicleName,
            vehicleBrandName,
            vehicleModelName,
            vehicleTypeName,
            vehicleColorName,
            vehicleFrame,
            vehicleMadeYear,
            vehicleModelYear,
            vehiclePlate,
            contractBilling,
            contractNumber,
            monthBilling,
            deviceIdentifier,
            vehicleBrandsList,
            vehicleColorsList,
            vehicleModelsList,
            vehicleTypesList,
            useSatellite,
            deviceSatelliteIdentifier,
            deviceCameraIdentifier,
            getCurrentUser.configs.isManager,
        ],
    );

    const onUpdateStatus = useCallback(
        async (id: number, status: string) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const customerId =
                location?.state?.customerId ??
                (!getCurrentUser.configs.isManager
                    ? currentParameters.customer.id
                    : customer.id);

            setLoading(true);
            try {
                await updateVehicleStatusById(token, id, customerId, status);
                setTextValidation("Registro atualizado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
            } catch (error: any) {
                const { data } = error.response;

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    getAllVehicles();
                }, 8000);
            }
        },
        [
            cookies.token,
            location?.state?.customerId,
            getAllVehicles,
            handleClose,
            currentParameters.customer.id,
            customer.id,
            getCurrentUser.configs.isManager,
        ],
    );

    const getReport = useCallback(
        async (type: string) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const customerId =
                location?.state?.customerId ??
                (!getCurrentUser.configs.isManager
                    ? currentParameters.customer.id
                    : customer.id);
            const departmentId =
                location?.state?.departmentId ??
                (!getCurrentUser.configs.isManager && !currentParameters.isViewingAll
                    ? currentParameters.department.id
                    : department.id);
            const isViewAll =
                getCurrentUser.configs.isManager && !location?.state?.departmentId
                    ? isViewingAll
                    : !getCurrentUser.configs.isManager && currentParameters.isViewingAll;

            let reportType = type;
            let isSimpleType = false;
            if (type.includes("simple")) {
                reportType = reportType.split(" ")[0];
                isSimpleType = true;
            }

            setLoading(true);
            let dataBuffer = new ArrayBuffer(0);
            try {
                const { data } = await findAllVehiclesExportResponse(
                    token,
                    customerId,
                    departmentId,
                    vehicleList.length > 0 && vehicleList[0].activated
                        ? "activated"
                        : "deactivated",
                    reportType,
                    isViewAll,
                    isSimpleType,
                );

                if ((data as ArrayBuffer).byteLength === 0) {
                    setTextValidation("Nenhum dado para mostrar no relatório.");
                    setStatusMessage("warn");
                    setFieldsIsValid(false);
                } else {
                    setTextValidation("Relatório gerado com sucesso.");
                    setStatusMessage("success");
                    setFieldsIsValid(false);
                    dataBuffer = data;
                }
            } catch (error: any) {
                const { data } = error.response;

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    setReport(dataBuffer);
                    setExportType(type);
                }, 3000);
            }
        },
        [
            cookies.token,
            location?.state?.customerId,
            location?.state?.departmentId,
            vehicleList,
            handleClose,
            currentParameters.customer.id,
            currentParameters.department.id,
            currentParameters.isViewingAll,
            isViewingAll,
            customer.id,
            department.id,
            getCurrentUser.configs.isManager,
        ],
    );

    useEffect(() => {
        if (report.byteLength > 1) {
            const typeExport =
                exportType === "pdf"
                    ? "application/pdf"
                    : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const file = new Blob([report], { type: typeExport });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            setReport(new ArrayBuffer(0));
        }
    }, [report, exportType]);

    const verifyBeforeUpdateStatus = useCallback(
        (id: number, status: string) => {
            const ref = toastModalRef;
            if (!isToastVisible) {
                setToastRefToOpen(
                    ref,
                    "Deseja realmente atualizar o status desse registro?",
                    "Atenção!",
                    statusMessage,
                    {
                        content: (props: ContentProps) => (
                            <Box
                                className="flex flex-column align-items-left"
                                style={{ flex: "1" }}
                            >
                                <Typography>{props?.message.summary}</Typography>
                                <Box className="font-medium text-lg my-3 text-900">
                                    {props?.message.detail}
                                </Box>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                        onUpdateStatus(id, status);
                                    }}
                                >
                                    Sim
                                </Button>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                    }}
                                >
                                    Não
                                </Button>
                            </Box>
                        ),
                    },
                    undefined,
                    true,
                );
                setIsToastVisible(true);
            }
        },
        [onUpdateStatus, isToastVisible, statusMessage],
    );

    const loadingEsqueleton = useMemo(() => {
        return (
            <Grid
                className="container "
                sx={{
                    height: 650,
                    width: 950,
                }}
            >
                {Array.from(new Array(1)).map((_, i) => (
                    <Box key={i} sx={{ width: "100%", height: 650, padding: 5 }}>
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                    </Box>
                ))}
            </Grid>
        );
    }, []);

    const handleOnEditValues = useCallback(
        (selectedVehicle: VehicleType) => {
            if (selectedVehicle?.name && !inInsert) {
                const brandName =
                    vehicleBrandsList.find(
                        (item) => item.id === selectedVehicle.vehicleBrandId,
                    )?.name ?? null;

                const modelName =
                    vehicleModelsList.find(
                        (item) => item.id === selectedVehicle.vehicleModelId,
                    )?.name ?? null;

                const typeName = vehicleTypesList.find(
                    (item) => item.id === selectedVehicle.vehicleTypeId,
                )?.name;

                const colorName = vehicleColorsList.find(
                    (item) => item.id === selectedVehicle.vehicleColorId,
                )?.name;

                setVehicleName(selectedVehicle.name);
                setVehiclePlate(selectedVehicle.vehiclePlate);

                setVehicleBrandName(brandName ?? "");
                setVehicleModelName(modelName ?? "");

                setVehicleTypeName(typeName!!);
                setVehicleFrame(selectedVehicle?.vehicleFrame);
                selectedVehicle?.vehicleMadeYear &&
                    setVehicleMadeYear(dayjs().year(selectedVehicle?.vehicleMadeYear));
                selectedVehicle?.vehicleModelYear &&
                    setVehicleModelYear(dayjs().year(selectedVehicle?.vehicleModelYear));
                setContractNumber(selectedVehicle?.contractNumber);
                selectedVehicle?.monthBilling &&
                    setMonthBilling(currencyFormatter(selectedVehicle.monthBilling));
                selectedVehicle?.contractBilling &&
                    setContractBiling(
                        currencyFormatter(selectedVehicle?.contractBilling),
                    );
                setDeviceIdentifier(selectedVehicle?.deviceImei ?? null);
                setDeviceCameraIdentifier(selectedVehicle?.deviceCameraImei ?? null);
                setVehicleColorName(colorName!!);
                setUseSatellite(selectedVehicle.useSatellite);
                setDeviceSatelliteIdentifier(selectedVehicle?.satelliteImei ?? null);
            }
        },
        [
            inInsert,
            vehicleBrandsList,
            vehicleTypesList,
            vehicleColorsList,
            vehicleModelsList,
        ],
    );

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(query);
        }, 1000);

        return () => clearTimeout(handler);
    }, [query]);

    const getBySearch = useCallback(() => {
        if (
            (customer.name && secretary.name && department.name && !isViewingAll) ||
            (!getCurrentUser.configs.isManager && getCurrentUser.customer.name) ||
            (getCurrentUser.configs.isManager && isViewingAll && customer.name)
        ) {
            const localResult = getFilteredList(
                [
                    "name",
                    "vehiclePlate",
                    "deviceImei",
                    "satelliteImei",
                    "contractNumber",
                    "vehicleFrame",
                ],
                vehicleList,
                debouncedQuery,
            );

            if (localResult.length > 0) {
                setFilteredList(localResult);
            } else {
                setFilteredList([]);
            }

            if (debouncedQuery !== lastRemoteQuery && localResult.length <= 0) {
                setLastRemoteQuery(debouncedQuery);
                getAllVehicles(debouncedQuery);
            }
        }
    }, [
        debouncedQuery,
        getAllVehicles,
        vehicleList,
        customer.name,
        secretary.name,
        department.name,
        getCurrentUser.configs.isManager,
        getCurrentUser.customer.name,
        isViewingAll,
        lastRemoteQuery,
    ]);

    useEffect(() => {
        getBySearch();
    }, [getBySearch]);

    const deviceCameraFieldDialog = useMemo(() => {
        return (
            <Dialog
                open={isOpenDialogCameraField}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    className: "tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl",
                    sx: { borderRadius: 4, backgroundColor: "#ffff", boxShadow: "0 24px 70px rgba(0,0,0,0.28)" },
                }}
            >
                <Box className="tw-bg-white" sx={{ background: "#ffff" }}>
                    <Box
                        className="tw-bg-gtr-sidebar tw-px-5 tw-py-4 tw-text-white"
                        sx={{ backgroundImage: "linear-gradient(to right, #006C77, #09414A)", padding: { xs: 2, sm: 2.5 } }}
                    >
                        <Typography sx={{ color: "#ffff", fontFamily: "Prometo", fontSize: { xs: 18, sm: 21 }, fontWeight: 700 }}>
                            Dispositivo da câmera
                        </Typography>
                    </Box>
                    <Paper
                        className="tw-m-4 tw-rounded-xl tw-border tw-border-black/10 tw-bg-white tw-p-4"
                        sx={{ boxShadow: "none", padding: 2, margin: 2, background: "#ffff", border: "1px solid rgba(0,63,74,0.10)", borderRadius: 3 }}
                    >
                        <DialogContent className="row tw-m-0 tw-p-0" sx={{ margin: 0, padding: 0 }}>
                            <Box className="col-sm-12">
                                <FormControl
                                    className="form-group"
                                    style={{ display: "flex", width: "100%" }}
                                >
                                    <InputLabel
                                        id="device-label"
                                        shrink
                                        disabled={
                                            !getCurrentUser.configs.isManager ||
                                            ((selectedVehicle?.name &&
                                                !inEdit &&
                                                !inInsert) as boolean)
                                        }
                                        style={{ fontFamily: "Prometo" }}
                                    >
                                        Dispositivo Camera
                                    </InputLabel>
                                    <TextField
                                        name="deviceCamera"
                                        InputProps={{
                                            label: "Dispositivo camera",
                                            notched: true,
                                            style: { fontFamily: "Prometo" },
                                        }}
                                        disabled={
                                            !getCurrentUser.configs.isManager ||
                                            ((selectedVehicle?.name &&
                                                !inEdit &&
                                                !inInsert) as boolean)
                                        }
                                        value={deviceCameraIdentifier}
                                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                            setDeviceCameraIdentifier(event.target.value);
                                        }}
                                        type="text"
                                        autoComplete="off"
                                        className="form-control form-control-login"
                                        placeholder="Digite o identificador do dispositivo."
                                        inputProps={{ maxLength: 9 }}
                                    />
                                    <IconButton
                                        className="visibility-password"
                                        disabled
                                        onMouseDown={(e: SyntheticEvent) => { }}
                                        edge="end"
                                        size="large"
                                    >
                                        <VideoCameraFrontOutlined />
                                    </IconButton>
                                </FormControl>
                            </Box>
                        </DialogContent>
                    </Paper>

                    <DialogActions sx={{ borderTop: "1px solid rgba(0,0,0,0.10)", padding: 2 }}>
                            <Box
                                className="tw-flex tw-w-full tw-justify-end"
                                sx={{ display: "flex", width: "100%", justifyContent: "flex-end", paddingTop: 2 }}
                            >
                            <Paper
                                elevation={0}
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        background: "transparent",
                                        marginLeft: "auto",
                                    }}
                            >
                                <Button
                                    type="button"
                                    style={{ fontFamily: "Prometo", color: "#ffff" }}
                                    disabled={false}
                                    onClick={() => {
                                        if (!isToastVisible) {
                                            setIsOpenDialogCameraField(false);
                                        }
                                    }}
                                    className="btn btn-primary btn-block login-button-close"
                                >
                                    <CloseOutlined style={{ marginRight: 5 }} />
                                    <Typography sx={{ color: "#fff", fontFamily: "Prometo", fontWeight: 700 }}>
                                        Fechar
                                    </Typography>
                                </Button>
                            </Paper>
                        </Box>
                    </DialogActions>
                </Box>
            </Dialog>
        );
    }, [
        isOpenDialogCameraField,
        deviceCameraIdentifier,
        getCurrentUser.configs.isManager,
        handleClose,
        inEdit,
        inInsert,
        isToastVisible,
        selectedVehicle?.name,
    ]);

    const deviceHistoryDialog = useMemo(() => {
        return (
            <Dialog
                open={isOpenDialog}
                onClose={handleCloseHistory}
                fullWidth
                maxWidth="md"
                aria-labelledby="responsive-dialog-title"
                PaperProps={{
                    className: "tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl",
                    sx: { borderRadius: 4, backgroundColor: "#ffff", boxShadow: "0 24px 70px rgba(0,0,0,0.28)" },
                }}
            >
                <Box className="tw-bg-white tw-p-4 sm:tw-p-6" sx={{ p: { xs: 2, sm: 3 }, background: "#ffff" }}>
                    <Box
                        className="tw-mb-4 tw-flex tw-flex-col tw-gap-3 tw-rounded-xl tw-bg-gtr-sidebar tw-p-4 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between"
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            justifyContent: "space-between",
                            alignItems: { sm: "center" },
                            gap: 1.5,
                            mb: 2,
                            p: 2,
                            borderRadius: 3,
                            backgroundImage: "linear-gradient(to right, #006C77, #09414A)",
                        }}
                    >
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "bold", fontFamily: "Prometo", color: "#ffff" }}
                        >
                            Histórico de Trocas de Dispositivos — {selectedVehicle?.name}
                        </Typography>
                        <TextField
                            size="small"
                            placeholder="Pesquisar IMEI..."
                            value={historySearch}
                            onChange={(e) => setHistorySearch(e.target.value)}
                            sx={{
                                width: { xs: "100%", sm: "240px" },
                                "& .MuiInputBase-root": {
                                    height: "36px",
                                    fontFamily: "Prometo",
                                    fontSize: "13px",
                                    backgroundColor: "#fff",
                                    borderRadius: 2,
                                },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <SearchOutlined
                                        sx={{ fontSize: 18, mr: 0.5, color: "#666" }}
                                    />
                                ),
                                endAdornment: historySearch && (
                                    <IconButton size="small" onClick={() => setHistorySearch("")}>
                                        <CloseOutlined sx={{ fontSize: 16 }} />
                                    </IconButton>
                                ),
                            }}
                        />
                    </Box>

                    <TableContainer
                        className="tw-rounded-xl"
                        component={Paper}
                        sx={{
                            maxHeight: 400,
                            boxShadow: "none",
                            border: "1px solid #e0e0e0",
                            borderRadius: 3,
                            overflowY: "auto",
                            scrollbarWidth: "thin",
                            scrollbarColor: "#c1c1c1 transparent",
                            "&::-webkit-scrollbar": { width: "5px" },
                            "&::-webkit-scrollbar-track": { background: "transparent" },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#c1c1c1",
                                borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                                backgroundColor: "#9e9e9e",
                            },
                        }}
                    >
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            fontFamily: "Prometo",
                                            fontSize: "12px",
                                            background: "#09414A",
                                            color: "#fff",
                                        }}
                                    >
                                        IMEI
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            fontFamily: "Prometo",
                                            fontSize: "12px",
                                            background: "#09414A",
                                            color: "#fff",
                                        }}
                                    >
                                        Tipo
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            fontFamily: "Prometo",
                                            fontSize: "12px",
                                            background: "#09414A",
                                            color: "#fff",
                                        }}
                                    >
                                        Status vinculo
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            fontFamily: "Prometo",
                                            fontSize: "12px",
                                            background: "#09414A",
                                            color: "#fff",
                                        }}
                                    >
                                        Status dispositivo
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            fontFamily: "Prometo",
                                            fontSize: "12px",
                                            background: "#09414A",
                                            color: "#fff",
                                        }}
                                    >
                                        Período do vínculo
                                    </TableCell>
                                    {getCurrentUser.accessProfile.id ===
                                        Number(PROFILE_ACESSES.ADMIN) && (
                                            <TableCell
                                                sx={{
                                                    fontWeight: "bold",
                                                    fontFamily: "Prometo",
                                                    fontSize: "12px",
                                                    background: "#09414A",
                                                    color: "#fff",
                                                }}
                                            >
                                                Última posição
                                            </TableCell>
                                        )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(() => {
                                    const filtered = selectedVehicle?.deviceHistory?.filter(
                                        (item: any) =>
                                            !historySearch ||
                                            item.deviceImei
                                                ?.toLowerCase()
                                                .includes(historySearch.toLowerCase()),
                                    );

                                    if (!filtered || filtered.length === 0) {
                                        return (
                                            <TableRow sx={{ animation: "fadeIn 0.3s ease-out" }}>
                                                <TableCell
                                                    colSpan={6}
                                                    align="center"
                                                    sx={{
                                                        py: 6,
                                                        color: "#666",
                                                        fontFamily: "Prometo",
                                                        fontStyle: "italic",
                                                    }}
                                                >
                                                    Nenhum dado encontrado
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }

                                    return filtered.map((item: any, idx: number) => (
                                        <TableRow
                                            key={item.id || idx}
                                            hover
                                            sx={{
                                                animation: "fadeIn 0.3s ease-out forwards",
                                                opacity: 0,
                                                "@keyframes fadeIn": {
                                                    "0%": { opacity: 0, transform: "translateY(8px)" },
                                                    "100%": { opacity: 1, transform: "translateY(0)" },
                                                },
                                                transition: "background-color 0.2s ease",
                                            }}
                                        >
                                            <TableCell
                                                sx={{ fontFamily: "Prometo", fontSize: "12px" }}
                                            >
                                                {item.deviceImei ?? "—"}
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontFamily: "Prometo", fontSize: "12px" }}
                                            >
                                                <Chip
                                                    size="small"
                                                    label={item.type || "—"}
                                                    icon={<DeviceHubOutlined style={{ fontSize: 14 }} />}
                                                    sx={{ fontFamily: "Prometo", fontSize: "11px" }}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    size="small"
                                                    label={item.activated ? "Ativo" : "Removido"}
                                                    icon={
                                                        <CheckCircleOutlineOutlined
                                                            style={{
                                                                fontSize: 14,
                                                                color: item.activated ? "#0FB403" : "#dc3545",
                                                            }}
                                                        />
                                                    }
                                                    sx={{
                                                        fontFamily: "Prometo",
                                                        fontSize: "11px",
                                                        color: item.activated ? "#0FB403" : "#dc3545",
                                                        borderColor: item.activated ? "#0FB403" : "#dc3545",
                                                    }}
                                                    variant="outlined"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    size="small"
                                                    label={item.deviceActivated ? "Ativo" : "Inativo"}
                                                    icon={
                                                        <CheckCircleOutlineOutlined
                                                            style={{
                                                                fontSize: 14,
                                                                color: item.deviceActivated
                                                                    ? "#0FB403"
                                                                    : "#dc3545",
                                                            }}
                                                        />
                                                    }
                                                    sx={{
                                                        fontFamily: "Prometo",
                                                        fontSize: "11px",
                                                        color: item.deviceActivated ? "#0FB403" : "#dc3545",
                                                        borderColor: item.deviceActivated
                                                            ? "#0FB403"
                                                            : "#dc3545",
                                                    }}
                                                    variant="outlined"
                                                />
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    fontFamily: "Prometo",
                                                    fontSize: "12px",
                                                    color: "#b77700",
                                                }}
                                            >
                                                <div>
                                                    Início: {item.createdAt
                                                        ? dayjs(item.createdAt).format("DD/MM/YYYY HH:mm")
                                                        : "—"}
                                                </div>
                                                <div>
                                                    Fim: {item.updatedAt
                                                        ? dayjs(item.updatedAt).format("DD/MM/YYYY HH:mm")
                                                        : "—"}
                                                </div>
                                            </TableCell>
                                            {getCurrentUser.accessProfile.id ===
                                                Number(PROFILE_ACESSES.ADMIN) && (
                                                    <TableCell
                                                        sx={{
                                                            fontFamily: "Prometo",
                                                            fontSize: "12px",
                                                            color: "#b77700",
                                                        }}
                                                    >
                                                        {item.deviceLastUpdate
                                                            ? dayjs(item.deviceLastUpdate).format(
                                                                "DD/MM/YYYY HH:mm",
                                                            )
                                                            : "—"}
                                                    </TableCell>
                                                )}
                                        </TableRow>
                                    ));
                                })()}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <DialogActions sx={{ px: 0, pb: 0, pt: 2, borderTop: "1px solid rgba(0,0,0,0.08)", mt: 2 }}>
                        <Button
                            onClick={handleCloseHistory}
                            variant="contained"
                            sx={{
                                background: "#dc3545",
                                color: "#fff",
                                fontFamily: "Prometo",
                                textTransform: "none",
                                "&:hover": { background: "#c82333" },
                            }}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        );
    }, [
        getCurrentUser.accessProfile.id,
        selectedVehicle?.deviceHistory,
        selectedVehicle?.name,
        isOpenDialog,
        historySearch,
        handleCloseHistory,
    ]);

    const DetailsModal = useMemo(() => {
        return (
            <Rmodal
                open={isOpenDetails}
                hiddenBackdrop={false}
                toast={
                    <Toast
                        ref={toastModalRef}
                        position="center"
                        onShow={() => {
                            setIsToastVisible(true);

                            if (validationText) {
                                setTimeout(() => {
                                    setFieldsIsValid(true);
                                    setIsToastVisible(false);
                                }, 3000);
                            }
                        }}
                    />
                }
            >
                <Paper
                    className="tw-flex tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                    sx={style}
                >
                    <Box
                        className="row tw-m-0 tw-flex-1 tw-overflow-y-auto tw-bg-white tw-p-4 sm:tw-p-6"
                        sx={{
                            margin: 0,
                            width: "100%",
                            flex: 1,
                            overflowY: "auto",
                            backgroundColor: "#ffff",
                            boxShadow: "none",
                            padding: { xs: 2, sm: 3 },
                            scrollbarWidth: "thin",
                            scrollbarColor: "#006C77 transparent",
                            "& .MuiOutlinedInput-root": { borderRadius: 2, backgroundColor: "#ffff", transition: "box-shadow 200ms ease, background-color 200ms ease" },
                            "& .MuiOutlinedInput-root:hover": { backgroundColor: "rgba(0, 108, 119, 0.02)" },
                            "& .MuiOutlinedInput-root.Mui-focused": { boxShadow: "0 0 0 3px rgba(0, 108, 119, 0.10)" },
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#006C77" },
                            "& .MuiAccordion-root": { border: "1px solid rgba(0,63,74,0.10)", borderRadius: "12px !important", boxShadow: "none", overflow: "hidden" },
                        }}
                    >
                        {!loading ? (
                            <>
                                {!info2Expanded && (
                                    <>
                                        <Box className="col-sm-12 col-md-7 d-none d-md-flex">
                                            <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                                                Identificação
                                            </Typography>
                                        </Box>
                                        <Box
                                            className="col-sm-12 col-md-5"
                                            style={{ display: "flex", justifyContent: "end" }}
                                        >
                                            {selectedVehicle?.name && (
                                                <>
                                                    <Chip
                                                        style={{
                                                            color: selectedVehicle.activated
                                                                ? "#00B700"
                                                                : "#dc3545",
                                                            marginRight: 5,
                                                            width: "50%",
                                                            fontWeight: "bolder",
                                                        }}
                                                        clickable={false}
                                                        onClick={() => { }}
                                                        label={
                                                            selectedVehicle.activated ? "Ativo" : "Inativo"
                                                        }
                                                    />
                                                    <Chip
                                                        className="crud-metadata-chip"
                                                        style={{
                                                            color: "black",
                                                            marginRight: 5,
                                                            fontWeight: "bolder",
                                                        }}
                                                        clickable={false}
                                                        onClick={() => { }}
                                                        label={selectedVehicle.createdAt}
                                                    />
                                                    {selectedVehicle.activated && (
                                                        <Chip
                                                            style={{
                                                                color: "black",
                                                                marginRight: 5,
                                                                width: "50%",
                                                            }}
                                                            disabled={
                                                                location?.state?.canEdit == false ||
                                                                location?.state?.permissions?.canEdit ==
                                                                false ||
                                                                isImpersonationLocked()
                                                            }
                                                            onClick={() => {
                                                                setInEdit(true);
                                                            }}
                                                            label="Editar"
                                                            icon={
                                                                <DriveFileRenameOutlineOutlined
                                                                    style={{
                                                                        height: 24,
                                                                        width: 24,
                                                                        fill: "black",
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    )}
                                                    {selectedVehicle.activated && canTransferVehicle && !inEdit && (
                                                        <Chip
                                                            style={{
                                                                color: "black",
                                                                marginRight: 5,
                                                            }}
                                                            onClick={() => openVehicleTransfer(selectedVehicle)}
                                                            label="Transferir"
                                                            icon={
                                                                <SwapHorizOutlined
                                                                    style={{
                                                                        height: 24,
                                                                        width: 24,
                                                                        fill: "black",
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    )}
                                                    <Chip
                                                        style={{
                                                            color: "black",
                                                            marginRight: 5,
                                                            width: "50%",
                                                        }}
                                                        disabled={
                                                            location?.state?.canEdit == false ||
                                                            location?.state?.permissions?.canEdit == false ||
                                                            isImpersonationLocked()
                                                        }
                                                        onClick={() => {
                                                            if (!isToastVisible) {
                                                                verifyBeforeUpdateStatus(
                                                                    selectedVehicle.id,
                                                                    selectedVehicle.activated
                                                                        ? "deactivate"
                                                                        : "activate",
                                                                );
                                                            }
                                                        }}
                                                        label={
                                                            selectedVehicle.activated ? "Desativar" : "Ativar"
                                                        }
                                                        icon={
                                                            <RemoveCircleOutlineOutlined
                                                                style={{ height: 24, width: 24, fill: "black" }}
                                                            />
                                                        }
                                                    />
                                                </>
                                            )}
                                        </Box>
                                    </>
                                )}

                                <Accordion
                                    expanded={infoExpanded}
                                    style={{ padding: 0, margin: 0, boxShadow: "none" }}
                                >
                                    <AccordionSummary
                                        style={{ margin: 0, boxShadow: "none", display: "none" }}
                                        aria-controls="panel2-content"
                                        id="panel2-header"
                                    ></AccordionSummary>
                                    <AccordionDetails>
                                        <Box className="row">
                                            {currentParameters?.isViewingAll && inInsert && (
                                                <>
                                                    <Box
                                                        className="col-md-6"
                                                        style={{ marginBottom: 10 }}
                                                    >
                                                        <Autocomplete
                                                            id="chip-label-select-secretary"
                                                            className="input-select-secretary"
                                                            style={{
                                                                width: "100%",
                                                                minHeight: "56px",
                                                                height: "56px",
                                                                backgroundColor: "#ffffff29",
                                                                borderColor: "lightgray",
                                                            }}
                                                            options={secretariesList}
                                                            value={secretary}
                                                            onChange={(_, option) => {
                                                                setSecretary(option ?? secretaryDefault);
                                                                setDepartment(departmentDefault);
                                                            }}
                                                            disabled={
                                                                (inEdit || (!inEdit && !inInsert)) as boolean
                                                            }
                                                            getOptionLabel={(option) =>
                                                                `${option.reducedName}`
                                                            }
                                                            noOptionsText={"Nada encontrado"}
                                                            renderInput={(params) => (
                                                                <>
                                                                    <FormControl
                                                                        className="form-group"
                                                                        style={{ display: "flex" }}
                                                                    >
                                                                        <InputLabel
                                                                            id="country-label"
                                                                            required
                                                                            style={{
                                                                                color: "rgba(0, 0, 0, 0.6)",
                                                                                fontFamily: "Prometo",
                                                                            }}
                                                                            shrink
                                                                        >
                                                                            Secretaria
                                                                        </InputLabel>
                                                                        <TextField
                                                                            {...params}
                                                                            variant="outlined"
                                                                            placeholder="Selecione uma secretaria"
                                                                            autoComplete="off"
                                                                            required
                                                                            InputLabelProps={{ shrink: true }}
                                                                            InputProps={{
                                                                                ...params.InputProps,
                                                                                notched: true,
                                                                                label: "Secretaria",
                                                                                classes: {
                                                                                    notchedOutline: "custom-notch",
                                                                                },
                                                                            }}
                                                                        />
                                                                    </FormControl>
                                                                </>
                                                            )}
                                                        />
                                                    </Box>

                                                    <Box
                                                        className="col-md-6"
                                                        style={{ marginBottom: 10 }}
                                                    >
                                                        <Autocomplete
                                                            id="chip-label-select-department"
                                                            className="input-select-department"
                                                            style={{
                                                                width: "100%",
                                                                minHeight: "56px",
                                                                height: "56px",
                                                                backgroundColor: "#ffffff29",
                                                                borderColor: "lightgray",
                                                            }}
                                                            options={departmentsList}
                                                            value={department}
                                                            onChange={(_, option) => {
                                                                setDepartment(option ?? departmentDefault);
                                                            }}
                                                            disabled={
                                                                (inEdit || (!inEdit && !inInsert)) as boolean
                                                            }
                                                            getOptionLabel={(option) =>
                                                                `${option.reducedName}`
                                                            }
                                                            noOptionsText={"Nada encontrado"}
                                                            renderInput={(params) => (
                                                                <>
                                                                    <FormControl
                                                                        className="form-group"
                                                                        style={{ display: "flex" }}
                                                                    >
                                                                        <InputLabel
                                                                            id="country-label"
                                                                            required
                                                                            style={{
                                                                                color: "rgba(0, 0, 0, 0.6)",
                                                                                fontFamily: "Prometo",
                                                                            }}
                                                                            shrink
                                                                        >
                                                                            Departamento
                                                                        </InputLabel>
                                                                        <TextField
                                                                            {...params}
                                                                            variant="outlined"
                                                                            placeholder="Selecione um departamento"
                                                                            autoComplete="off"
                                                                            required
                                                                            InputLabelProps={{ shrink: true }}
                                                                            InputProps={{
                                                                                ...params.InputProps,
                                                                                notched: true,
                                                                                label: "Departamento",
                                                                                classes: {
                                                                                    notchedOutline: "custom-notch",
                                                                                },
                                                                            }}
                                                                        />
                                                                    </FormControl>
                                                                </>
                                                            )}
                                                        />
                                                    </Box>
                                                </>
                                            )}

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-name-label"
                                                        shrink
                                                        disabled={
                                                            (selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        required
                                                        style={{ fontFamily: "Prometo" }}
                                                    >
                                                        Nome
                                                    </InputLabel>
                                                    <TextField
                                                        name="name"
                                                        InputProps={{
                                                            label: "Nome",
                                                            notched: true,
                                                            style: { fontFamily: "Prometo" },
                                                        }}
                                                        disabled={
                                                            (selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        value={vehicleName}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>,
                                                        ) => {
                                                            setVehicleName(event.target.value);
                                                        }}
                                                        type="text"
                                                        autoComplete="off"
                                                        required
                                                        className="form-control form-control-login"
                                                        placeholder="Digite um nome ou apelido para o veiculo."
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(event: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <AbcOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="plate-label"
                                                        shrink
                                                        required
                                                        error={isPlateInvalid}
                                                        disabled={
                                                            (selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    >
                                                        Placa
                                                    </InputLabel>
                                                    <TextField
                                                        name="plate"
                                                        type="text"
                                                        autoComplete="off"
                                                        required
                                                        error={isPlateInvalid}
                                                        helperText={isPlateInvalid ? "Placa inválida." : undefined}
                                                        inputProps={{ maxLength: 7 }}
                                                        InputProps={{ label: "Placa", notched: true }}
                                                        placeholder="Digite o placa do veículo."
                                                        className="form-control vehicle-plate"
                                                        value={vehiclePlate}
                                                        onChange={(
                                                            event: React.ChangeEvent<HTMLInputElement>,
                                                        ) => {
                                                            setVehiclePlate(event.target.value);
                                                        }}
                                                        onBlur={() => {
                                                            const plate = normalizePlate(vehiclePlate);
                                                            if (plate !== vehiclePlate) setVehiclePlate(plate);
                                                            setPlateBlurredValue(plate);
                                                            lookupPlateNow();
                                                        }}
                                                        disabled={
                                                            (selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <PinOutlined />
                                                    </IconButton>
                                                </FormControl>
                                                <Box style={{ marginTop: "8px" }}>
                                                    <DirectdIndicators
                                                        loading={directdLoading}
                                                        indicators={directdResult?.indicators ?? null}
                                                        consultedAt={directdResult?.consultedAt}
                                                        stale={directdResult?.stale}
                                                        error={directdError}
                                                    />
                                                </Box>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <Autocomplete
                                                    id="chip-label-select-state"
                                                    className="input-select-state"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "56px",
                                                        height: "56px",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    disabled={
                                                        (selectedVehicle?.name &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                    options={vehicleBrandsList}
                                                    value={
                                                        vehicleBrandsList.find(
                                                            (a) => a.name === vehicleBrandName,
                                                        ) ?? null
                                                    }
                                                    onChange={(_, option) => {
                                                        setVehicleBrandName(option?.name ?? "");
                                                        setVehicleModelName("");
                                                    }}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    noOptionsText={"Nada encontrado"}
                                                    renderInput={(params) => (
                                                        <>
                                                            <FormControl
                                                                className="form-group"
                                                                style={{ display: "flex" }}
                                                            >
                                                                <InputLabel
                                                                    id="brand-label"
                                                                    style={{
                                                                        color: "rgba(0, 0, 0, 0.6)",
                                                                        fontFamily: "Prometo",
                                                                    }}
                                                                    disabled={
                                                                        (selectedVehicle?.name &&
                                                                            !inEdit &&
                                                                            !inInsert) as boolean
                                                                    }
                                                                    shrink
                                                                >
                                                                    Marca
                                                                </InputLabel>
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    placeholder="Selecione uma marca (Opcional)"
                                                                    autoComplete="off"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        notched: true,
                                                                        label: "Marca",
                                                                        classes: {
                                                                            notchedOutline: "custom-notch",
                                                                        },
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </>
                                                    )}
                                                />
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <Autocomplete
                                                    id="chip-label-select-state"
                                                    className="input-select-state"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "56px",
                                                        height: "56px",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    disabled={
                                                        (selectedVehicle?.name &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                    options={vehicleModelsList}
                                                    value={
                                                        vehicleModelsList.find(
                                                            (a) => a.name === vehicleModelName,
                                                        ) ?? null
                                                    }
                                                    onChange={(_, option) => {
                                                        setVehicleModelName(option?.name ?? "");
                                                    }}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    noOptionsText={"Nada encontrado"}
                                                    renderInput={(params) => (
                                                        <>
                                                            <FormControl
                                                                className="form-group"
                                                                style={{ display: "flex" }}
                                                            >
                                                                <InputLabel
                                                                    id="model-label"
                                                                    style={{
                                                                        color: "rgba(0, 0, 0, 0.6)",
                                                                        fontFamily: "Prometo",
                                                                    }}
                                                                    disabled={
                                                                        (selectedVehicle?.name &&
                                                                            !inEdit &&
                                                                            !inInsert) as boolean
                                                                    }
                                                                    shrink
                                                                >
                                                                    Modelo
                                                                </InputLabel>
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    placeholder="Selecione um modelo (Opcional)"
                                                                    autoComplete="off"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        notched: true,
                                                                        label: "Modelo",
                                                                        classes: {
                                                                            notchedOutline: "custom-notch",
                                                                        },
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </>
                                                    )}
                                                />
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <Autocomplete
                                                    id="chip-label-select-type"
                                                    className="input-select-type"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "56px",
                                                        height: "56px",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    disabled={
                                                        (selectedVehicle?.name &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                    options={vehicleTypesList}
                                                    value={
                                                        vehicleTypesList.find(
                                                            (a) => a.name === vehicleTypeName,
                                                        ) ?? null
                                                    }
                                                    onChange={(_, option) => {
                                                        setVehicleTypeName(option?.name ?? "");
                                                    }}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    noOptionsText={"Nada encontrado"}
                                                    renderInput={(params) => (
                                                        <>
                                                            <FormControl
                                                                className="form-group"
                                                                style={{ display: "flex" }}
                                                            >
                                                                <InputLabel
                                                                    id="type-label"
                                                                    required
                                                                    style={{
                                                                        color: "rgba(0, 0, 0, 0.6)",
                                                                        fontFamily: "Prometo",
                                                                    }}
                                                                    disabled={
                                                                        (selectedVehicle?.name &&
                                                                            !inEdit &&
                                                                            !inInsert) as boolean
                                                                    }
                                                                    shrink
                                                                >
                                                                    Tipo
                                                                </InputLabel>
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    placeholder="Selecione um tipo"
                                                                    autoComplete="off"
                                                                    required
                                                                    InputLabelProps={{ shrink: true }}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        notched: true,
                                                                        label: "Tipo",
                                                                        classes: {
                                                                            notchedOutline: "custom-notch",
                                                                        },
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </>
                                                    )}
                                                />
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <Autocomplete
                                                    id="chip-label-select-color"
                                                    className="input-select-color"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "56px",
                                                        height: "56px",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    disabled={
                                                        (selectedVehicle?.name &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                    options={vehicleColorsList}
                                                    value={
                                                        vehicleColorsList.find(
                                                            (a) => a.name === vehicleColorName,
                                                        ) ?? null
                                                    }
                                                    getOptionLabel={(option) => `${option.description}`}
                                                    onChange={(_, option) => {
                                                        setVehicleColorName(option?.name ?? "");
                                                    }}
                                                    noOptionsText={"Nada encontrado"}
                                                    renderInput={(params) => (
                                                        <>
                                                            <FormControl
                                                                className="form-group"
                                                                style={{ display: "flex" }}
                                                            >
                                                                <InputLabel
                                                                    id="color-label"
                                                                    required
                                                                    style={{
                                                                        color: "rgba(0, 0, 0, 0.6)",
                                                                        fontFamily: "Prometo",
                                                                    }}
                                                                    disabled={
                                                                        (selectedVehicle?.name &&
                                                                            !inEdit &&
                                                                            !inInsert) as boolean
                                                                    }
                                                                    shrink
                                                                >
                                                                    Cor
                                                                </InputLabel>
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    placeholder="Selecione uma cor"
                                                                    autoComplete="off"
                                                                    required
                                                                    InputLabelProps={{ shrink: true }}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        startAdornment: (
                                                                            <LocalShippingRounded
                                                                                style={{
                                                                                    fill: `${vehicleColorsList.find(
                                                                                        (a) =>
                                                                                            a.name === vehicleColorName,
                                                                                    )?.name ?? "gray"
                                                                                        }`,
                                                                                }}
                                                                            />
                                                                        ),
                                                                        notched: true,
                                                                        label: "Cor",
                                                                        classes: {
                                                                            notchedOutline: "custom-notch",
                                                                        },
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </>
                                                    )}
                                                />
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="frame-label"
                                                        shrink
                                                        disabled={
                                                            (selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        style={{ fontFamily: "Prometo" }}
                                                    >
                                                        Chassí
                                                    </InputLabel>
                                                    <TextField
                                                        name="frame"
                                                        InputProps={{
                                                            label: "Chassi",
                                                            notched: true,
                                                            style: { fontFamily: "Prometo" },
                                                        }}
                                                        inputProps={{ maxLength: 17 }}
                                                        disabled={
                                                            (selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        value={vehicleFrame}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>,
                                                        ) => {
                                                            setVehicleFrame(event.target.value);
                                                        }}
                                                        type="text"
                                                        autoComplete="off"
                                                        className="form-control form-control-login"
                                                        placeholder="Digite o número do chassí (Opcional)"
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <PinOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{
                                                        width: "100%",
                                                        marginRight: 5,
                                                        marginLeft: 5,
                                                    }}
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterDayjs}
                                                        adapterLocale={"pt-br"}
                                                    >
                                                        <DatePicker
                                                            sx={{ width: "100%" }}
                                                            label={"Ano fabricação"}
                                                            format="YYYY"
                                                            views={["year"]}
                                                            localeText={{ toolbarTitle: "" }}
                                                            slotProps={{
                                                                textField: {
                                                                    required: false,
                                                                },
                                                            }}
                                                            onChange={(value) => {
                                                                value?.isValid() && setVehicleMadeYear(value);
                                                            }}
                                                            value={vehicleMadeYear}
                                                            disabled={
                                                                (selectedVehicle?.name &&
                                                                    !inEdit &&
                                                                    !inInsert) as boolean
                                                            }
                                                            maxDate={dayjs().add(1, "year").endOf("day")}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{
                                                        width: "100%",
                                                        marginRight: 5,
                                                        marginLeft: 5,
                                                    }}
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterDayjs}
                                                        adapterLocale={"pt-br"}
                                                    >
                                                        <DatePicker
                                                            sx={{ width: "100%" }}
                                                            label={"Ano modelo"}
                                                            format="YYYY"
                                                            views={["year"]}
                                                            openTo="year"
                                                            onChange={(value) => {
                                                                value?.isValid() && setVehicleModelYear(value);
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    required: false,
                                                                },
                                                            }}
                                                            value={vehicleModelYear}
                                                            disabled={
                                                                (selectedVehicle?.name &&
                                                                    !inEdit &&
                                                                    !inInsert) as boolean
                                                            }
                                                            minDate={vehicleMadeYear}
                                                            maxDate={vehicleMadeYear.add(1, "year")}
                                                        />
                                                    </LocalizationProvider>
                                                    <Box
                                                        style={{
                                                            display: "flex",
                                                            marginTop: 10,
                                                            marginLeft: -15,
                                                        }}
                                                    >
                                                        <FormHelperText
                                                            style={{
                                                                color: "red",
                                                                display: "flex",
                                                            }}
                                                        >
                                                            {invalidVehicleDates &&
                                                                "O ano do modelo deve ser 1 ano superior ou igual ao ano de fabricação."}
                                                        </FormHelperText>
                                                    </Box>
                                                </FormControl>
                                            </Box>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>

                                <Box
                                    className="crud-additional-info-bar col-sm-12 col-md-7 d-none d-md-flex"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        background: "#f3f4f6",
                                    }}
                                    onClick={() => {
                                        setInfo2Expanded(!info2Expanded);
                                        setInfoExpanded(!infoExpanded);
                                    }}
                                >
                                    <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                                        Informações adicionais
                                    </Typography>
                                    <Tooltip
                                        title={"Clique para adicionar informações administrativas."}
                                        style={{ color: "black", margin: 5, cursor: "pointer" }}
                                    >
                                        <HelpOutlineOutlined />
                                    </Tooltip>
                                </Box>

                                <Box
                                    className="crud-additional-info-bar col-sm-12 col-md-5"
                                    style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        cursor: "pointer",
                                        background: "#f3f4f6",
                                    }}
                                    onClick={() => {
                                        setInfo2Expanded(!info2Expanded);
                                        setInfoExpanded(!infoExpanded);
                                    }}
                                >
                                    <IconButton onClick={() => { }} edge="end" size="large">
                                        <ArrowDropDownIcon
                                            style={{
                                                transform: info2Expanded ? "rotate(180deg)" : "",
                                            }}
                                        />
                                    </IconButton>
                                </Box>

                                <Accordion
                                    expanded={info2Expanded}
                                    style={{
                                        padding: 0,
                                        margin: 0,
                                        boxShadow: "none",
                                        marginTop: 5,
                                    }}
                                >
                                    <IconButton
                                        aria-label="toggle accordion"
                                        className="d-none"
                                        onClick={() => { }}
                                        edge="end"
                                        size="large"
                                    >
                                        <ArrowDropDownIcon />
                                    </IconButton>
                                    <AccordionDetails>
                                        <Box className="row">
                                            <Box
                                                className="col-md-10"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                }}
                                            ></Box>

                                            <Box
                                                className="col-md-2"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <Chip
                                                    style={{
                                                        color: "#ffff",
                                                        width: "100%",
                                                        fontWeight: "bolder",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        justifyItems: "center",
                                                        alignItems: "center",
                                                        paddingLeft: 6,
                                                        background: "#003f4a",
                                                    }}
                                                    disabled={
                                                        !getCurrentUser.configs.isManager ||
                                                        ((selectedVehicle?.name &&
                                                            !inEdit &&
                                                            !inInsert) as boolean)
                                                    }
                                                    clickable={false}
                                                    onClick={() => {
                                                        setIsOpenDialogCameraField(true);
                                                    }}
                                                    icon={
                                                        <VideoCameraFrontOutlined
                                                            style={{ color: "#ffff", alignSelf: "center" }}
                                                        />
                                                    }
                                                    label={""}
                                                />

                                                <Tooltip
                                                    title={
                                                        "Clique para adicionar um dispositivo do tipo câmera."
                                                    }
                                                    style={{
                                                        color: "black",
                                                        margin: 5,
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <HelpOutlineOutlined />
                                                </Tooltip>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="contract-label"
                                                        shrink
                                                        disabled={
                                                            !getCurrentUser.configs.isManager ||
                                                            ((selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean)
                                                        }
                                                    >
                                                        Número de contrato
                                                    </InputLabel>
                                                    <TextField
                                                        name="contractNumber"
                                                        type="text"
                                                        autoComplete="off"
                                                        InputProps={{
                                                            label: "Número de contrato",
                                                            notched: true,
                                                        }}
                                                        inputProps={{ maxLength: 8 }}
                                                        placeholder="Digite o número de contrato (Opcional)."
                                                        className="form-control contract-number"
                                                        value={contractNumber}
                                                        onChange={(
                                                            event: React.ChangeEvent<HTMLInputElement>,
                                                        ) => {
                                                            setContractNumber(event.target.value);
                                                        }}
                                                        disabled={
                                                            !getCurrentUser.configs.isManager ||
                                                            ((selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean)
                                                        }
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <DescriptionOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="month-billing-label"
                                                        shrink
                                                        disabled={
                                                            !getCurrentUser.configs.isManager ||
                                                            ((selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean)
                                                        }
                                                        style={{ fontFamily: "Prometo" }}
                                                    >
                                                        Valor mensal
                                                    </InputLabel>
                                                    <TextField
                                                        name="monthBilling"
                                                        InputProps={{
                                                            label: "Valor mensal",
                                                            notched: true,
                                                            style: { fontFamily: "Prometo" },
                                                        }}
                                                        disabled={
                                                            !getCurrentUser.configs.isManager ||
                                                            ((selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean)
                                                        }
                                                        value={currencyFormatter(monthBilling || "")}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>,
                                                        ) => {
                                                            setMonthBilling(event.target.value);
                                                        }}
                                                        type="text"
                                                        autoComplete="off"
                                                        className="form-control form-control-login"
                                                        placeholder="Digite o valor mensal (Opcional)."
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <LocalAtmOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="contractBilling-label"
                                                        shrink
                                                        disabled={
                                                            !getCurrentUser.configs.isManager ||
                                                            ((selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean)
                                                        }
                                                        style={{ fontFamily: "Prometo" }}
                                                    >
                                                        Valor do contrato
                                                    </InputLabel>
                                                    <TextField
                                                        name="contractBilling"
                                                        InputProps={{
                                                            label: "Valor do contrato",
                                                            notched: true,
                                                            style: { fontFamily: "Prometo" },
                                                        }}
                                                        disabled={
                                                            !getCurrentUser.configs.isManager ||
                                                            ((selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean)
                                                        }
                                                        value={currencyFormatter(contractBilling || "")}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>,
                                                        ) => {
                                                            setContractBiling(event.target.value);
                                                        }}
                                                        type="text"
                                                        autoComplete="off"
                                                        className="form-control form-control-login"
                                                        placeholder="Digite o valor de contrato (Opcional)."
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <RequestPageOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="device-label"
                                                        shrink
                                                        disabled={
                                                            !getCurrentUser.configs.isManager ||
                                                            ((selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean)
                                                        }
                                                        required={false}
                                                        style={{ fontFamily: "Prometo" }}
                                                    >
                                                        Dispositivo
                                                    </InputLabel>
                                                    <TextField
                                                        name="device"
                                                        InputProps={{
                                                            label: "Dispositivo",
                                                            notched: true,
                                                            style: { fontFamily: "Prometo" },
                                                        }}
                                                        disabled={
                                                            !getCurrentUser.configs.isManager ||
                                                            ((selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean)
                                                        }
                                                        value={deviceIdentifier}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>,
                                                        ) => {
                                                            setDeviceIdentifier(event.target.value);
                                                        }}
                                                        type="text"
                                                        autoComplete="off"
                                                        required={false}
                                                        className="form-control form-control-login"
                                                        placeholder="Digite o identificador (IMEI)."
                                                        inputProps={{ maxLength: 15 }}
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <TapAndPlayOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-10"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormGroup>
                                                    <Stack
                                                        direction="row"
                                                        spacing={1}
                                                        sx={{ alignItems: "center" }}
                                                    >
                                                        <IOSSwitch
                                                            title="Usar dispotitivo via satélite"
                                                            checked={useSatellite}
                                                            disabled={
                                                                !getCurrentUser.configs.isManager ||
                                                                ((selectedVehicle?.name &&
                                                                    !inEdit &&
                                                                    !inInsert) as boolean)
                                                            }
                                                            onChange={(event) => {
                                                                const checked = event.target.checked;

                                                                if (!checked) {
                                                                    setDeviceSatelliteIdentifier("");
                                                                }
                                                                setUseSatellite(checked);
                                                            }}
                                                            inputProps={{ "aria-label": "ant design" }}
                                                        />
                                                        <Typography style={{ color: "gray" }}>
                                                            Usa satelital
                                                        </Typography>
                                                    </Stack>
                                                </FormGroup>
                                            </Box>

                                            <Box
                                                className="col-md-12"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="device-label"
                                                        shrink
                                                        disabled={
                                                            !getCurrentUser.configs.isManager ||
                                                            ((selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean)
                                                        }
                                                        required={useSatellite}
                                                        style={{ fontFamily: "Prometo" }}
                                                    >
                                                        Dispositivo satelital
                                                    </InputLabel>
                                                    <TextField
                                                        name="device"
                                                        InputProps={{
                                                            label: "Dispositivo satelital",
                                                            notched: true,
                                                            style: { fontFamily: "Prometo" },
                                                        }}
                                                        disabled={
                                                            !getCurrentUser.configs.isManager ||
                                                            ((selectedVehicle?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean) ||
                                                            !useSatellite
                                                        }
                                                        value={deviceSatelliteIdentifier}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>,
                                                        ) => {
                                                            setDeviceSatelliteIdentifier(event.target.value);
                                                        }}
                                                        type="text"
                                                        autoComplete="off"
                                                        required={useSatellite}
                                                        className="form-control form-control-login"
                                                        placeholder="Digite o identificador (ESN)."
                                                        inputProps={{ maxLength: 9 }}
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <SatelliteAltOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-12"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                {selectedVehicle.updatedAt && (
                                                    <Chip
                                                        className="crud-metadata-chip"
                                                        style={{
                                                            color: "black",
                                                            marginRight: 5,
                                                            fontWeight: "bolder",
                                                        }}
                                                        clickable={false}
                                                        onClick={() => { }}
                                                        label={`Última alteração: ${selectedVehicle.updatedAt}`}
                                                    />
                                                )}

                                                <Chip
                                                    className="crud-metadata-chip"
                                                    style={{
                                                        color: "black",
                                                        marginRight: 5,
                                                        fontWeight: "bolder",
                                                    }}
                                                    clickable={false}
                                                    onClick={() => { }}
                                                    label={`Troca de dispositivo em: ${selectedVehicle.changeOfDeviceAt ? selectedVehicle.changeOfDeviceAt : "Não houve"}`}
                                                />
                                                <Chip
                                                    style={{
                                                        fontFamily: "Prometo",
                                                        color: "#ffff",
                                                        marginRight: 5,
                                                    }}
                                                    color="info"
                                                    disabled={!selectedVehicle.changeOfDeviceAt}
                                                    onClick={() => {
                                                        setIsOpenDialog(true);
                                                    }}
                                                    icon={
                                                        <TapAndPlayOutlined style={{ color: "#ffff" }} />
                                                    }
                                                    className="btn btn-info"
                                                    label={`Histórico de trocas`}
                                                />
                                                {/*<Chip
                                                    style={{ fontFamily: "Prometo", color: "#fff", marginRight: 5 }}
                                                    color="info"
                                                    onClick={() => {
                                                        setIsOpenVehicleParameter(true);
                                                    }}
                                                    icon={<Settings style={{ color: "#ffff" }} />}
                                                    className="btn btn-info"
                                                    label={`Parâmetros do veículo`}
                                                />*/}
                                            </Box>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </>
                        ) : (
                            loadingEsqueleton
                        )}
                    </Box>
                    <Box
                        className="tw-flex tw-w-full tw-flex-none tw-justify-end tw-border-t tw-border-black/10 tw-bg-white tw-p-4"
                        sx={{ display: "flex", width: "100%", alignSelf: "stretch", justifyContent: "flex-end", padding: 2, borderTop: "1px solid rgba(0,0,0,0.10)", backgroundColor: "#ffff" }}
                    >
                        <Paper
                            className="tw-flex tw-w-full tw-flex-col-reverse tw-gap-2 sm:tw-w-auto sm:tw-flex-row"
                            elevation={0}
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column-reverse", sm: "row" },
                                justifyContent: "flex-end",
                                width: { xs: "100%", sm: "auto" },
                                marginLeft: "auto",
                                alignSelf: "flex-end",
                                gap: 1,
                                background: "transparent",
                            }}
                        >
                            <Button
                                type="button"
                                style={{
                                    fontFamily: "Prometo",
                                    color: "#ffff",
                                    marginRight: 5,
                                }}
                                onClick={() => {
                                    if (!isToastVisible) {
                                        verifyBeforeCancel(selectedVehicle);
                                    }
                                }}
                                className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <CloseOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Fechar
                                </Typography>
                            </Button>
                            <Button
                                type="button"
                                style={{ fontFamily: "Prometo", color: "#ffff" }}
                                disabled={!inEdit && !inInsert}
                                onClick={() => {
                                    inInsert && !inEdit ? onSave() : onUpdate();
                                }}
                                className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <SaveOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Salvar
                                </Typography>
                            </Button>
                        </Paper>
                    </Box>
                </Paper>
            </Rmodal>
        );
    }, [
        directdLoading,
        directdResult,
        directdError,
        lookupPlateNow,
        isPlateInvalid,
        canTransferVehicle,
        openVehicleTransfer,
        onSave,
        secretary,
        onUpdate,
        verifyBeforeUpdateStatus,
        invalidVehicleDates,
        verifyBeforeCancel,
        vehicleModelName,
        vehicleColorName,
        vehicleTypeName,
        vehicleFrame,
        vehicleMadeYear,
        vehicleModelYear,
        contractNumber,
        monthBilling,
        contractBilling,
        deviceIdentifier,
        vehicleBrandName,
        vehicleColorsList,
        vehicleTypesList,
        vehicleBrandsList,
        vehicleModelsList,
        vehiclePlate,
        vehicleName,
        infoExpanded,
        info2Expanded,
        location?.state?.canEdit,
        location?.state?.permissions?.canEdit,
        getCurrentUser.configs.isManager,
        currentParameters?.isViewingAll,
        department,
        departmentsList,
        secretariesList,
        isToastVisible,
        validationText,
        selectedVehicle,
        isOpenDetails,
        loading,
        loadingEsqueleton,
        inInsert,
        inEdit,
        deviceSatelliteIdentifier,
        useSatellite,
    ]);

    // Busca parâmetros do veículo selecionado
    const handleCloseVehiclePanel = useCallback(() => {
        verifyBeforeLeavingVehicleSection(() => {
            setIsOpenVehicleParameter(false);
            setVehicleDialogSection("parameters");
            setVehicleDialogHasUnsavedChanges(false);
        });
    }, [verifyBeforeLeavingVehicleSection]);

    const handleOpenVehicleParameters = useCallback(() => {
        verifyBeforeLeavingVehicleSection(() => {
            setVehicleDialogSection("parameters");
            setVehicleDialogHasUnsavedChanges(false);
        });
    }, [verifyBeforeLeavingVehicleSection]);

    useEffect(() => {
        if (!isOpenVehicleParameter) {
            setVehicleDialogContentHeight(null);
            return;
        }

        const contentElement = vehicleDialogContentRef.current;

        if (!contentElement) {
            return;
        }

        let animationFrameId = 0;

        const updateContentHeight = () => {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = requestAnimationFrame(() => {
                const nextHeight = Math.ceil(
                    contentElement.getBoundingClientRect().height,
                );

                if (nextHeight > 0) {
                    setVehicleDialogContentHeight((currentHeight) =>
                        currentHeight === nextHeight
                            ? currentHeight
                            : nextHeight,
                    );
                }
            });
        };

        updateContentHeight();

        if (typeof ResizeObserver === "undefined") {
            return () => cancelAnimationFrame(animationFrameId);
        }

        const resizeObserver = new ResizeObserver(updateContentHeight);
        resizeObserver.observe(contentElement);

        return () => {
            cancelAnimationFrame(animationFrameId);
            resizeObserver.disconnect();
        };
    }, [isOpenVehicleParameter, vehicleDialogSection]);

    const vehicleParameterDialog = useMemo(() => {
        const isDisabled =
            location?.state?.canEdit == false ||
            location?.state?.permissions?.canEdit == false ||
            isImpersonationLocked();


        const sectionTitle =
            vehicleDialogSection === "maintenance"
                ? "Manutenções"
                : vehicleDialogSection === "expenses"
                    ? "Despesas"
                    : vehicleDialogSection === "attachments"
                        ? "Anexos do veículo"
                        : "Parâmetros";

        return (
            <Dialog
                open={isOpenVehicleParameter}
                onClose={handleCloseVehiclePanel}
                fullWidth
                maxWidth={
                    vehicleDialogSection === "parameters" ? "md" : "lg"
                }
                aria-labelledby="vehicle-parameter-dialog-title"
                PaperProps={{
                    className: "tw-overflow-hidden tw-rounded-2xl tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth",
                    sx: {
                        backgroundColor: "#ffff",
                        boxShadow: "0 24px 70px rgba(0, 0, 0, 0.28)",
                        borderRadius: "16px",
                        padding: {
                            xs: 1,
                            sm: 2.5,
                        },
                        width: "100%",
                        maxHeight: {
                            xs: "calc(100vh - 24px)",
                            sm: "calc(100vh - 64px)",
                        },
                        overflow: "hidden",
                        transition:
                            "max-width 220ms cubic-bezier(0.4, 0, 0.2, 1)",
                        "@media (prefers-reduced-motion: reduce)": {
                            transition: "none",
                        },
                    },
                }}
            >
                <Toast
                    ref={toastVehicleDialogRef}
                    position="center"
                    baseZIndex={1500}
                    onShow={() => {
                        setIsToastVisible(true);

                        if (validationText) {
                            setTimeout(() => {
                                setFieldsIsValid(true);
                                setIsToastVisible(false);
                            }, 3000);
                        }
                    }}
                />

                <Box
                    className="tw-flex tw-min-h-0 tw-flex-col tw-overflow-hidden tw-bg-white"
                    sx={{
                        background: "#ffff",
                        display: "flex",
                        flexDirection: "column",
                        minHeight: 0,
                        overflow: "hidden",
                    }}
                >
                    {/* ============================= */}
                    {/* CABEÇALHO                     */}
                    {/* ============================= */}

                    <Paper
                        className="tw-flex-none tw-bg-gtr-sidebar tw-text-white tw-shadow-sm"
                        elevation={0}
                        sx={{
                            backgroundImage: "linear-gradient(to right, #006C77, #09414A)",
                            borderRadius: "12px",
                            padding: "8px 12px",
                            marginBottom: 2,
                            color: "#fff",
                            flexShrink: 0,
                        }}
                    >
                        <Box
                            sx={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                minHeight: "45px",
                                width: "100%",
                            }}
                        >
                            {vehicleDialogSection !== "parameters" && (
                                <Tooltip title="Voltar para parâmetros" arrow>
                                    <IconButton
                                        aria-label="Voltar para parâmetros"
                                        onClick={handleOpenVehicleParameters}
                                        sx={{
                                            color: "#fff",
                                            marginRight: 1,
                                        }}
                                    >
                                        <ArrowBackOutlined />
                                    </IconButton>
                                </Tooltip>
                            )}

                            <Typography
                                variant="body1"
                                sx={{
                                    fontWeight: "bolder",
                                    fontFamily: "Prometo",
                                    fontSize: "18px",
                                }}
                            >
                                {sectionTitle} — {selectedVehicle?.name}
                            </Typography>

                            {/* MAIS OPÇÕES */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    right: 0,
                                    top: "50%",

                                    transform: "translateY(-50%)",

                                    display: "flex",

                                    alignItems: "center",

                                    flexDirection: "row-reverse",

                                    width: "45px",

                                    height: "45px",

                                    overflow: "hidden",

                                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",

                                    borderRadius: "25px",

                                    backgroundColor: "rgba(255,255,255,0.05)",

                                    zIndex: 10,

                                    "&:hover": {
                                        width: "190px",

                                        backgroundColor: "rgba(255,255,255,0.15)",

                                        paddingRight: "5px",
                                    },

                                    "&:hover .vehicle-options-container": {
                                        opacity: 1,

                                        transform: "translateX(0)",
                                    },
                                }}
                            >
                                <Tooltip title="Mais opções" arrow>
                                    <IconButton
                                        aria-label="Mais opções"
                                        onClick={(e) => e.stopPropagation()}
                                        sx={{
                                            color: "#fff",

                                            minWidth: "45px",

                                            width: "45px",

                                            height: "45px",
                                        }}
                                    >
                                        <SettingsOutlined />
                                    </IconButton>
                                </Tooltip>

                                <Box
                                    className="vehicle-options-container"
                                    sx={{
                                        display: "flex",

                                        alignItems: "center",

                                        gap: 1,

                                        opacity: 0,

                                        transform: "translateX(20px)",

                                        transition: "all 0.3s ease-out",

                                        paddingRight: "5px",

                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    <Tooltip title="Manutenções" arrow>
                                        <IconButton
                                            aria-label="Abrir manutenções"
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                handleOpenVehicleMaintenance();
                                            }}
                                            sx={{
                                                background: "#00b700",

                                                width: "32px",

                                                height: "32px",

                                                "&:hover": {
                                                    background: "#009900",
                                                },
                                            }}
                                        >
                                            <BuildOutlined sx={{ color: "#fff", fontSize: "1.1rem" }} />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Despesas" arrow>
                                        <IconButton
                                            aria-label="Abrir despesas"
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                handleOpenVehicleExpenses();
                                            }}
                                            sx={{
                                                background: "#0ec8e6",

                                                width: "32px",

                                                height: "32px",

                                                "&:hover": {
                                                    background: "#0aa9c2",
                                                },
                                            }}
                                        >
                                            <AttachMoneyOutlined sx={{ color: "#fff", fontSize: "1.1rem" }} />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Anexos do veículo" arrow>
                                        <IconButton
                                            aria-label="Abrir anexos do veículo"
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                handleOpenVehicleAttachments();
                                            }}
                                            sx={{
                                                background: "#6c757d",

                                                width: "32px",

                                                height: "32px",

                                                "&:hover": {
                                                    background: "#5a6268",
                                                },
                                            }}
                                        >
                                            <AttachFileOutlined sx={{ color: "#fff", fontSize: "1.1rem" }} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>
                    </Paper>

                    {/* ============================= */}
                    {/* PARÂMETROS                    */}
                    {/* ============================= */}

                    <Box
                        className="tw-overflow-x-hidden tw-overflow-y-auto tw-rounded-xl tw-bg-white"
                        key={vehicleDialogSection}
                        role="region"
                        aria-label={sectionTitle}
                        sx={{
                            flex: "0 1 auto",
                            minHeight: 0,
                            height:
                                vehicleDialogContentHeight === null
                                    ? "auto"
                                    : `${vehicleDialogContentHeight}px`,
                            overflowX: "hidden",
                            overflowY: "auto",
                            paddingRight: 0.5,
                            scrollbarGutter: "stable",
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            transition:
                                "height 220ms cubic-bezier(0.4, 0, 0.2, 1)",
                            animation:
                                "vehicle-section-enter 200ms cubic-bezier(0.4, 0, 0.2, 1)",
                            willChange: "height, opacity, transform",
                            "@keyframes vehicle-section-enter": {
                                from: {
                                    opacity: 0,
                                    transform: "translateY(6px)",
                                },
                                to: {
                                    opacity: 1,
                                    transform: "translateY(0)",
                                },
                            },
                            "@media (prefers-reduced-motion: reduce)": {
                                animation: "none",
                                transition: "none",
                            },
                        }}
                    >
                        <Box ref={vehicleDialogContentRef}>
                            {vehicleDialogSection === "parameters" && (
                            <VehicleParameter
                                vehicleId={selectedVehicle?.id ?? -1}
                                customerId={
                                    location?.state?.customerId ??
                                    (!getCurrentUser.configs.isManager
                                        ? currentParameters.customer.id
                                        : customer.id)
                                }
                                section="parameters"
                                isDisabled={isDisabled}
                                setTextValidation={setTextValidation}
                                setStatusMessage={setStatusMessage}
                                setFieldsIsValid={setFieldsIsValid}
                                onUnsavedChangesChange={
                                    setVehicleDialogHasUnsavedChanges
                                }
                                onClose={handleCloseVehiclePanel}
                            />
                            )}

                        {/* ============================= */}
                        {/* MANUTENÇÕES                   */}
                        {/* ============================= */}

                            {vehicleDialogSection === "maintenance" && (
                            <VehicleMaintenance
                                vehicleId={selectedVehicle?.id ?? -1}
                                departmentId={selectedVehicle?.departmentId ?? -1}
                                customerId={
                                    location?.state?.customerId ??
                                    (!getCurrentUser.configs.isManager
                                        ? currentParameters.customer.id
                                        : customer.id)
                                }
                                isDisabled={isDisabled}
                                setTextValidation={setTextValidation}
                                setStatusMessage={setStatusMessage}
                                setFieldsIsValid={setFieldsIsValid}
                                requestCancelConfirmation={
                                    requestVehicleDialogConfirmation
                                }
                                onUnsavedChangesChange={
                                    setVehicleDialogHasUnsavedChanges
                                }
                            />
                            )}

                        {/* ============================= */}
                        {/* DESPESAS                      */}
                        {/* ============================= */}

                            {vehicleDialogSection === "expenses" && (
                            <VehicleExpense
                                vehicleId={selectedVehicle?.id ?? -1}
                                customerId={
                                    location?.state?.customerId ??
                                    (!getCurrentUser.configs.isManager
                                        ? currentParameters.customer.id
                                        : customer.id)
                                }
                                isDisabled={isDisabled}
                                setTextValidation={setTextValidation}
                                setStatusMessage={setStatusMessage}
                                setFieldsIsValid={setFieldsIsValid}
                                requestCancelConfirmation={
                                    requestVehicleDialogConfirmation
                                }
                                onUnsavedChangesChange={
                                    setVehicleDialogHasUnsavedChanges
                                }
                            />
                            )}

                        {/* ============================= */}
                        {/* ANEXOS DO VEÍCULO             */}
                        {/* ============================= */}

                            {vehicleDialogSection === "attachments" && (
                            <VehicleParameter
                                vehicleId={selectedVehicle?.id ?? -1}
                                customerId={
                                    location?.state?.customerId ??
                                    (!getCurrentUser.configs.isManager
                                        ? currentParameters.customer.id
                                        : customer.id)
                                }
                                section="attachments"
                                isDisabled={isDisabled}
                                setTextValidation={setTextValidation}
                                setStatusMessage={setStatusMessage}
                                setFieldsIsValid={setFieldsIsValid}
                                onUnsavedChangesChange={
                                    setVehicleDialogHasUnsavedChanges
                                }
                                onClose={handleCloseVehiclePanel}
                            />
                            )}
                        </Box>
                    </Box>
                </Box>
            </Dialog>
        );
    }, [
        isOpenVehicleParameter,
        vehicleDialogSection,
        vehicleDialogContentHeight,
        selectedVehicle?.id,
        selectedVehicle?.departmentId,
        selectedVehicle?.name,
        location?.state?.canEdit,
        location?.state?.permissions?.canEdit,
        location?.state?.customerId,
        getCurrentUser.configs.isManager,
        currentParameters.customer.id,
        customer.id,
        validationText,
        handleCloseVehiclePanel,
        handleOpenVehicleParameters,
        handleOpenVehicleMaintenance,
        handleOpenVehicleExpenses,
        handleOpenVehicleAttachments,
        requestVehicleDialogConfirmation,
    ]);

    const getCustomersList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        try {
            const response = await customerFindAllListResponse(
                token,
                cookies.selectedParameters.customer.id,
            );
            setCustomersList(response.data);
        } catch (error) {
            console.log(error);
            setCustomersList([]);
        }
    }, [cookies.token, cookies.selectedParameters.customer.id]);

    useEffect(() => {
        if (
            getCurrentUser.configs.isManager &&
            location?.state?.customerId === undefined
        ) {
            getCustomersList();
        }
    }, [
        getCustomersList,
        getCurrentUser.configs.isManager,
        location?.state?.customerId,
    ]);

    const getSecretariesManagerList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = customer.id;

        try {
            const response = await findAllSecretariesByCustomerIdListResponse(
                token,
                customerId,
            );
            setSecretariesList(response.data);
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, customer?.id]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager && customer?.name) {
            getSecretariesManagerList();
        }
    }, [
        getSecretariesManagerList,
        customer?.name,
        getCurrentUser.configs.isManager,
    ]);

    const getDepartmentsManagerList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId =
            location?.state?.customerId ??
            (!getCurrentUser.configs.isManager
                ? currentParameters.customer.id
                : customer.id);
        const secretaryId = secretary.id;

        try {
            const response =
                await findAllDepartmentsByCustomerIdAndSecretaryIdListResponse(
                    token,
                    customerId,
                    secretaryId,
                );
            setDepartmentsList(response.data);
        } catch (error) {
            console.log(error);
            setDepartmentsList([]);
        }
    }, [
        cookies.token,
        customer.id,
        secretary.id,
        location?.state?.customerId,
        getCurrentUser.configs.isManager,
        currentParameters.customer.id,
    ]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager && customer?.name && secretary?.name) {
            getDepartmentsManagerList();
        }
    }, [
        getDepartmentsManagerList,
        secretary?.name,
        customer?.name,
        getCurrentUser.configs.isManager,
    ]);

    const customerParam = useMemo(
        () => (
            <>
                {getCurrentUser.configs.isManager && (
                    <Box className="col-md-4" style={{ marginBottom: 10, marginTop: 10 }}>
                        <Autocomplete
                            id="chip-label-select-customer"
                            className="input-select-customer"
                            style={{
                                width: "100%",
                                minHeight: "56px",
                                height: "56px",
                                backgroundColor: "#11060629",
                                borderColor: "lightgray",
                            }}
                            options={customersList}
                            value={customer}
                            onChange={(_, option) => {
                                setCustomer(option ?? customerDefault);
                                setSecretary(secretaryDefault);
                                setDepartment(departmentDefault);
                            }}
                            getOptionLabel={(option) => `${option.reducedName}`}
                            noOptionsText={"Nada encontrado"}
                            renderInput={(params) => (
                                <>
                                    <FormControl
                                        className="form-group"
                                        style={{ display: "flex" }}
                                    >
                                        <InputLabel
                                            id="country-label"
                                            required
                                            style={{
                                                color: "rgba(0, 0, 0, 0.6)",
                                                fontFamily: "Prometo",
                                            }}
                                            shrink
                                        >
                                            Cliente
                                        </InputLabel>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder="Selecione um cliente"
                                            style={{ background: "#ffff", borderRadius: 5 }}
                                            autoComplete="off"
                                            required
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                ...params.InputProps,
                                                notched: true,
                                                label: "Cliente",
                                                classes: {
                                                    notchedOutline: "custom-notch",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </>
                            )}
                        />
                    </Box>
                )}

                <Box
                    className={
                        !getCurrentUser.configs.isManager ? "col-md-6" : "col-md-4"
                    }
                    style={{ marginBottom: 10, marginTop: 10 }}
                >
                    <Autocomplete
                        id="chip-label-select-secretary"
                        className="input-select-secretary"
                        style={{
                            width: "100%",
                            minHeight: "56px",
                            height: "56px",
                            backgroundColor: "#ffffff29",
                            borderColor: "lightgray",
                        }}
                        options={secretariesList}
                        disabled={isViewingAll}
                        value={secretary}
                        onChange={(_, option) => {
                            setSecretary(option ?? secretaryDefault);
                            setDepartment(departmentDefault);
                        }}
                        getOptionLabel={(option) => `${option.reducedName}`}
                        noOptionsText={"Nada encontrado"}
                        renderInput={(params) => (
                            <>
                                <FormControl className="form-group" style={{ display: "flex" }}>
                                    <InputLabel
                                        id="country-label"
                                        required
                                        style={{
                                            color: "rgba(0, 0, 0, 0.6)",
                                            fontFamily: "Prometo",
                                        }}
                                        shrink
                                    >
                                        Secretaria
                                    </InputLabel>
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Selecione uma secretaria"
                                        autoComplete="off"
                                        required
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            ...params.InputProps,
                                            notched: true,
                                            label: "Secretaria",
                                            classes: {
                                                notchedOutline: "custom-notch",
                                            },
                                        }}
                                    />
                                </FormControl>
                            </>
                        )}
                    />
                </Box>

                <Box
                    className={
                        !getCurrentUser.configs.isManager ? "col-md-6" : "col-md-4"
                    }
                    style={{ marginBottom: 10, marginTop: 10 }}
                >
                    <Autocomplete
                        id="chip-label-select-department"
                        className="input-select-department"
                        style={{
                            width: "100%",
                            minHeight: "56px",
                            height: "56px",
                            backgroundColor: "#ffffff29",
                            borderColor: "lightgray",
                        }}
                        disabled={isViewingAll}
                        options={departmentsList}
                        value={department}
                        onChange={(_, option) => {
                            setDepartment(option ?? departmentDefault);
                        }}
                        getOptionLabel={(option) => `${option.reducedName}`}
                        noOptionsText={"Nada encontrado"}
                        renderInput={(params) => (
                            <>
                                <FormControl className="form-group" style={{ display: "flex" }}>
                                    <InputLabel
                                        id="department-label"
                                        required
                                        style={{
                                            color: "rgba(0, 0, 0, 0.6)",
                                            fontFamily: "Prometo",
                                        }}
                                        shrink
                                    >
                                        Departamento
                                    </InputLabel>
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Selecione uma departamento"
                                        autoComplete="off"
                                        required
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            ...params.InputProps,
                                            notched: true,
                                            label: "Departamento",
                                            classes: {
                                                notchedOutline: "custom-notch",
                                            },
                                        }}
                                    />
                                </FormControl>
                            </>
                        )}
                    />
                </Box>
            </>
        ),
        [
            customer,
            customersList,
            department,
            departmentsList,
            getCurrentUser.configs.isManager,
            secretariesList,
            isViewingAll,
            secretary,
        ],
    );

    const template = useMemo(() => {
        return (
            <>
                {DetailsModal}
                {deviceHistoryDialog}
                {vehicleParameterDialog}
                {deviceCameraFieldDialog}
                <Toast
                    ref={toastRef}
                    position="center"
                    onShow={() => {
                        setIsToastVisible(true);

                        if (validationText) {
                            setTimeout(() => {
                                setFieldsIsValid(true);
                                setIsToastVisible(false);
                            }, 3000);
                        }
                    }}
                />
                <GridTemplate
                    columns={columns}
                    headerName={"Veículos"}
                    isHiddenMenu={isHiddenMenu}
                    isLoading={loading}
                    order={"asc"}
                    rows={rowsOptions(
                        filteredList,
                        setIsOpenVehicleParameter,
                        (vehicle: VehicleType) => {
                            setSelectedVehicle(vehicle);

                            setVehicleDialogSection("parameters");
                        },
                        undefined,
                        getCurrentUser.permissions,
                        true,
                        canTransferVehicle ? openVehicleTransfer : undefined,
                    )}
                    sortField="name"
                    withFilter={true}
                    withOptions={true}
                    query={query}
                    setQuery={(value: string) => setQuery(value)}
                    filterPlaceholder={"Nome, placa, dispositivo, contrato, chassi"}
                    onRefresh={getAllVehicles}
                    onExport={getReport}
                    disableAddButton={
                        location?.state?.canCreate == false ||
                        location?.state?.permissions?.canCreate == false
                    }
                    handleNext={(activated: string, page: number, size: number) =>
                        getAllVehicles("", activated, page, size)
                    }
                    handlePrevious={() => { }}
                    isLastPage={isLastPage}
                    totalPerPage={numberOfElementsPerPage}
                    currentPage={pageNumber}
                    totalElements={numberOfElements}
                    onAdd={() => {
                        setIsOpenDetails(true);
                        setInInsert(true);
                        setLoading(true);
                        setTimeout(() => {
                            setLoading(false);
                        }, 2000);
                    }}
                    onClickRow={(item: any) => {
                        setIsOpenDetails(true);
                        setSelectedVehicle(item);
                        handleOnEditValues(item);
                        setLoading(true);
                        setTimeout(() => {
                            setLoading(false);
                        }, 2000);
                    }}
                    withCustomerParameter={
                        location?.state?.customerId || !getCurrentUser.configs.isManager
                            ? false
                            : true
                    }
                    customerParameter={customerParam}
                    whithCustomerFilterOption={
                        !location?.state?.departmentId && getCurrentUser.configs.isManager
                    }
                    onSetCustomerFilter={setIsViewingAll}
                />
            </>
        );
    }, [
        DetailsModal,
        deviceHistoryDialog,
        vehicleParameterDialog,
        deviceCameraFieldDialog,
        isHiddenMenu,
        loading,
        filteredList,
        query,
        getAllVehicles,
        getReport,
        location?.state?.canCreate,
        getCurrentUser.permissions,
        location?.state?.customerId,
        location?.state?.departmentId,
        isLastPage,
        numberOfElementsPerPage,
        pageNumber,
        numberOfElements,
        getCurrentUser.configs.isManager,
        customerParam,
        validationText,
        handleOnEditValues,
        location?.state?.permissions,
        canTransferVehicle,
        openVehicleTransfer,
    ]);

    return template;
};

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: { xs: "calc(100vw - 24px)", sm: "min(94vw, 1180px)" },
    maxWidth: 1180,
    maxHeight: "calc(100dvh - 24px)",
    overflow: "hidden",
    bgcolor: "#ffff",
    border: "none",
    boxShadow: "none",
    borderRadius: 4,
    color: "black",
    justifyContent: "center",
    alignItems: "center",
    lineBreak: "anywhere",
    padding: 0,
    fontFamily: "Prometo",
};

export default VehiclePage;
